import { Component, Input, OnInit } from "@angular/core";
import { GlobalsService } from "src/app/api/globals.service";
import { AppComponent } from "src/app/app.component";
import { DragulaService } from "ng2-dragula";
import {
  LoadingController,
  PopoverController,
  ToastController,
} from "@ionic/angular";
import { elementAt, Observable, Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import * as $ from "jquery";
import { resolve } from "dns";
import { AlertController } from "@ionic/angular";

import { UUID } from "angular2-uuid";
import { ActividadesService } from "src/app/services/actividades.service";
import { AuthService } from "src/app/services/auth.service";
import { windowBounds } from "epubjs/types/utils/core";
import { DatePipe } from "@angular/common";
import { ComponentDataService } from "src/app/services/component-data.service";
import { environment } from "src/environments/environment";
import { data } from "jquery";
import { formatDate } from "@angular/common";
import { error } from "console";
import { ModalLoadFilesComponent } from "../modal-load-files/modal-load-files.component";

@Component({
  selector: "app-modificar-actividad-actividades",
  templateUrl: "./modificar-actividad-actividades.component.html",
  styleUrls: ["./modificar-actividad-actividades.component.scss"],
})
export class ModificarActividadActividadesComponent implements OnInit {
  @Input() public curso: any;
  @Input() public opcion: any;
  @Input() public modificacion: number;
  @Input() public actividadActual: any;

  validoCrear = true;
  validoGuardar = true;
  public i: number;

  public host = environment.host + "/";

  actividadActualSinMod: any;
  desactivado = false;
  modHabilidad = true;
  cronoleoUrl: string;

  arregloP: any = [];
  dateA = new Date();
  fecha = { start: "", end: "" };
  maxYear: number;
  public reload = true;
  public id_user = 0;
  displayUserData: any;
  ionicForm: FormGroup;
  ismobile;
  public validP: number = 1;
  public pasos: number;
  public pasos2: number = 1;
  public nombreActividad: string;
  public habilidad: any = [];
  public ejercicios: any = [];
  public ejerciciosData: any = [];
  public tipo_ejercicios: any = [];
  public select_tipo_ejercicio: number = 0;
  ejercicioSelected: number = 0;
  ejercicioActivo: number = 0;
  initreorder: boolean = true;
  id_pos = 1;
  items: FormArray;
  public activeOption: number = 0;
  id_option_file: number = 0;
  link_option_y: string = "";
  input_option_tipo: number = 0;
  input_option_tipoOP: number = 0;
  isFechaHoraEntrega = 0;
  indiceActual: number;

  ejerciciosModificados: any = [];

  bandera: number = 3;

  id_option_fileQ: number = 0;
  id_option_fileQ2: number = 0;
  input_option_tipoQ: number = 0;
  data_option_tipoQ: any = { tipo: "", value: "", object: null, b64: "" };
  input_option_Q: string = "";

  array_option_imgs: any = [];
  dataPuzzle: any = [];
  public opciones = [
    {
      id: 1,
      respuesta: "",
      verdadero: false,
    },
  ];

  //Modificaciones adicionales
  dataOpcionM: any = {
    id: 0,
    id_activi_mult: 0,
    opcion: "",
    object: null,
    recurso: null,
    file: null,
    tipo_recurso: "",
    vf: 0,
  };
  dataOpcionOrdenar: any = {
    id: 0,
    id_ordenar: 0,
    tipo: 0,
    input: "",
    recurso: null,
    file: null,
  };
  // let temp = { id: id, id_actividad: idA, active: false, tipo: tipoI, actividades: actividaesI };

  ejercicioActivoInfo: any;

  // -----

  listOpModificadasOM: any = [];

  //Creacion de ejercicios

  arregloOpcionM: any = {
    data: {
      explicacion: "",
      id: 0,
      id_actividad: 0,
      id_tipo: 1,
      pregunta: "",
      recurso: null,
      file: null,
      tipo_recurso: "",
    },
    dataOp: [],
  };

  varFV: any = {
    data: {
      explicacion: "",
      id: 0,
      id_actividad: 0,
      id_tipo: 2,
      pregunta: "",
      vf: 0,
    },
  };
  varCompletarE: any = {
    data: { explicacion: "", id: 0, id_actividad: 0, id_tipo: 3, pregunta: "" },
  };

  arregloOrdenar: any = {
    data: {
      explicacion: "",
      id: 0,
      id_actividad: 0,
      id_tipo: 4,
      nombre: "",
      tipo: 0,
    },
    dataOp: [],
  };

  arregloMemoria: any = {
    data: { code_name: "", id: 0, id_actividad: 0, id_tipo: 5 },
    dataOp: [],
  };

  arregloSopaLetras: any = {
    data: { code_name: "", id: 0, id_actividad: 0, id_tipo: 6 },
    dataOp: [],
  };

  // { codigo: "", id: 0, id_sopa: 0, palabra: "", tipo: "" }

  varClaseE: any = {
    data: {
      explicacion: "",
      id: 0,
      id_actividad: 0,
      id_tipo: 7,
      pregunta: "",
      vf: 0,
    },
  };

  varPreguntaA: any = {
    data: {
      explicacion: "",
      id: 0,
      id_actividad: 0,
      id_tipo: 8,
      pregunta: "",
      recurso: null,
      file: null,
      tipo_recurso: "",
    },
  };

  public ordenarS = JSON.parse(JSON.stringify(this.arregloOrdenar));
  public ordenarP = JSON.parse(JSON.stringify(this.arregloOrdenar));

  countopcion: number = 0;
  /**************** */
  public opcionExplicacion: string = "";
  public opcionPregunta: string = "";
  public paso3Active = false;
  public opMultipleData: any = [];
  public btnLinkyoutube = false;

  //Variables verdadero y falso
  public fvPregunta: string = "";
  public fvFV: string = "";
  public dataVF: any = [];

  //Variables completar el espacio
  textAreacomplateEspacio: string = "";
  explAreacomplateEspacio: string = "";
  respuestasAreacomplateEspacio: any = [];
  dataAreacomplateEspacio: any = { tipo: 0, valor: "", explicacion: "" };

  //Variables pregunta abierta
  input_pa_y: string = "";
  id_preguntaA_file: number = 0;
  input_preguntaA_tipo: number = 0;
  //Variables clase de explicacion
  id_claseExplicacion_file: number = 0;
  input_claseE_tipo: number = 0;
  input_ce_y: string = "";
  formato: string = "";
  data_ClaseExplicacion: any = {
    tipo: 0,
    explicaciontema: "",
    explicaciontemaExpl: "",
    recurso: { tipo: "", object: null },
  };

  //Variables ordenar
  AcOrdenarTipo: number = 1;
  ordenarExplicacion: string = "";
  ordenarArrayP: any = [{ tipo: 1, input: "", recurso: null, file: null }];
  ordenarArrayS: any = [{ tipo: 2, input: "", file: null }];
  data_ordenar: any = [{ tipo: 0, explicacion: "", data: null }];

  //Variables memoria
  //data_Memoria:any = [{id:0,recurso:{file:null}}];
  //memoriaArray:any = [{recurso:{b64:null,file:null}}];
  //saveMemoria()
  data_Memoria: any = [];
  memoriaArray: any = [];
  memoriaSize: any = { x: 6, y: 6 };
  memoriaArrayObj: any = [];
  memoriaArrayDeleteItems: string[] = [];
  memObjItems: any = [];
  memObjFile: any = [];
  itemEditMem: any;

  //Variables sopa de letras
  data_SopaLetras: any = { tipo: 0, valor: null };
  puzzleMin: any = { y: 5, x: 5 };
  puzzleMax: number = 10;
  puzzleObj: any = [];
  flagOpen: string = "";
  word: string = "";
  flagClosed: string = "";
  codigos: any = [];
  flagOpenTemp: string = "";
  palabras: any = [];
  palabraInput: string = "";

  actividadesEjercicios: any = [];
  actividadesHabilidades: any = [];

  private auth_key: string = "";
  public stringVar = new BehaviorSubject({ valid: false });
  public stringVar$ = this.stringVar.asObservable();

  prueba: any = { modificado: 0 };
  minYear: any;
  minInit: any;
  errorMessage: string = "";
  selectedFiles: (File | string)[] = [];
  form: FormGroup;
  maxLengthTextArea: number = 5000;
  constructor(
    public globalsService: GlobalsService,
    private dragulaService: DragulaService,
    private toastController: ToastController,
    public formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    public alertController: AlertController,
    private authService: AuthService,
    public actividadesService: ActividadesService,
    private datePipe: DatePipe,
    public dataService: ComponentDataService,
    public loadingCtrl: LoadingController,
    private fb: FormBuilder,
    private popoverCtrl: PopoverController
  ) {
    this.form = this.fb.group({
      images: [null, [Validators.required, this.fileValidator.bind(this)]],
    });
    //this.fecha = this.datePipe.transform(this.dateA, 'yyyy-MM-dd');
    // this.fecha = this.datePipe.transform(this.dateA, 'yyyy-MM-dd H:mm');
    this.maxYear = parseInt(this.datePipe.transform(this.dateA, "yyyy")) + 1;
    this.minYear = this.converDateIso(new Date()).split("T")[0];
    let auth_key = "";
    let init = 0;

    let promise = new Promise((resolve2) => {
      this.authService.userData$.subscribe((res: any) => {
        this.displayUserData = res;
        auth_key = this.displayUserData?.auth_key;
        this.id_user = this.displayUserData?.id;
        if (auth_key && init == 0) {
          init++;
          this.auth_key = auth_key;
          let promise = new Promise((resolve) => {
            this.actividadesService.getAll(auth_key).subscribe((response) => {
              let body: any = response;
              //btnHabilidades
              if (body.auth_key) {
                if (
                  body.data.tipo != undefined &&
                  body.data.habilidades != undefined
                ) {
                  let actividadesEjercicios = body.data.tipo;
                  let actividadesHabilidades = body.data.habilidades;
                  actividadesEjercicios.forEach((element, index, array) => {
                    let tempT = {
                      id: element.posicion,
                      titulo: element.titulo,
                      seleccionado: element.seleccionado == 0 ? false : true,
                    };

                    this.actividadesEjercicios.push(tempT);
                  });
                  actividadesHabilidades.forEach((element, index, array) => {
                    let tempH = {
                      index: element.id,
                      id: element.posicion,
                      titulo: element.titulo,
                      seleccionado: element.seleccionado == 0 ? false : true,
                      valor: element.valor,
                    };
                    this.actividadesHabilidades.push(tempH);
                    if (index == array.length - 1) {
                    }
                  });
                }
              } else {
                /*this.logoutAction();
                this.toastService.presentToast( "Debe iniciar sesión" );*/
              }

              //Si se recibieron todas las habilidades y ejercicios finaliza la promesa
              if (
                this.actividadesHabilidades.length == 8 &&
                this.actividadesEjercicios.length == 8
              ) {
                resolve(true);
              }
            });
          });

          promise.then((success) => {
            if (success) {
              resolve2(true);
            }
          });
        }
      });
    });

    promise.then((success) => {
      if (success) {
        this.inicializacion();
      }
    });

    this.ismobile = globalsService.isMobile;

    if (this.initreorder) {
      this.initreorder = false;
      this.dragulaService.drag("bag").subscribe(({ name, el, source }) => {
        //el.setAttribute('color', 'white');
      });

      this.dragulaService.removeModel("bag").subscribe(({ item }) => {
        this.toastController
          .create({
            message: "Pregunta removida: ",
            duration: 2000,
          })
          .then((toast) => toast.present());
      });

      this.dragulaService.dropModel("bag").subscribe(({ item }) => {});

      // ------------
      this.dragulaService.drag("bag2").subscribe(({ name, el, source }) => {
        //el.setAttribute('color', 'white');
      });

      this.dragulaService.removeModel("bag2").subscribe(({ item }) => {
        this.toastController
          .create({
            message: "Pregunta removida: ",
            duration: 2000,
          })
          .then((toast) => toast.present());
      });

      this.dragulaService.dropModel("bag2").subscribe(({ item }) => {});
      // ------------
      this.dragulaService.drag("bag3").subscribe(({ name, el, source }) => {
        //el.setAttribute('color', 'white');
      });

      this.dragulaService.removeModel("bag3").subscribe(({ item }) => {
        this.toastController
          .create({
            message: "Pregunta removida: ",
            duration: 2000,
          })
          .then((toast) => toast.present());
      });

      this.dragulaService.dropModel("bag3").subscribe(({ item }) => {});
    }
  }

  ngOnInit() {
    this.isFechaHoraEntrega = 0;

    const now = new Date();
    const dateTime = formatDate(now, "yyyy-MM-ddTHH:mm", "en-US");

    this.fecha.start = dateTime;
    this.fecha.end = dateTime;
  }

  inicializacion() {
    this.desactivado = false;
    this.pasos = this.validP;
    this.habilidad = this.btnHabilidades();
    this.tipo_ejercicios = this.btnTipoEjercicios();
    if (this.nombreActividad == "") {
      this.validP = 1;
      this.pasos = this.validP;
    }
    const form = new FormGroup({
      password: new FormControl("", Validators.minLength(2)),
      passwordConfirm: new FormControl("", Validators.minLength(2)),
    });
    this.ionicForm = this.formBuilder.group({
      opcion: this.formBuilder.array([]),
    });

    //Inicialización de los datos
    if (this.modificacion == 2) {
      this.desactivado = true;
    }

    //Inicialización de la actividad actual
    this.id_user = this.actividadActual.data[0].id_user;
    this.nombreActividad = this.actividadActual.data[0].nombre_actividad;

    if (
      this.actividadActual.data[0].fecha_fin &&
      this.actividadActual.data[0].fecha_fin != "0"
    ) {
      this.isFechaHoraEntrega = 1;
      this.fecha.start = this.converDateIso(
        new Date(this.actividadActual.data[0].fecha_inicio)
      );
      this.fecha.end = this.converDateIso(
        new Date(this.actividadActual.data[0].fecha_fin)
      );
      this.minInit = this.converDateIso(
        new Date(
          this.actividadActual.data[0].fecha_inicio != 0
            ? this.actividadActual.data[0].fecha_inicio.split(" ")[0]
            : 0
        )
      );
    }
    //Inicialización de las habilidades

    this.actividadesService
      .getHabilidades_Fecha(this.actividadActual.data)
      .subscribe((response) => {
        if (response.statusCode >= 200 && response.statusCode <= 299) {
          response.data.habilidades.forEach((hab) => {
            this.habilidadF(hab.id_habilidad - 1);
          });
        } else {
          //Error
        }
      });

    //Inicialización de los ejercicios

    console.log(
      "🚀 ~ this.actividadActual.activities.forEach ~ this.actividadActual:",
      this.actividadActual
    );
    this.actividadActual.activities.forEach((actividad) => {
      this.agregarEjercicioInicializado(
        actividad.data.id_tipo,
        actividad,
        this.actividadActual.data[0].id
      );
    });
    this.updateUrlImages();
    console.log("ejercicios: ", this.ejercicios);
    this.actividadActual.activities = this.ejercicios;
    //Se realiza la copia de información
    this.actividadActualSinMod = this.actividadActual;
    return;
  }

  //Agregar ejercicios

  agregarEjercicio() {
    this.validoCrear = false;
    this.validoGuardar = false;
    this.activeOption = null;

    this.respuestasAreacomplateEspacio = [];
    this.modificacion = 1;
    let id = 0;
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        let temp_id = element.id;
        if (id < temp_id) {
          id = temp_id;
        }
      });
      id++;
    } else {
      id = 1;
    }
    let temp = { id: id, active: false, tipo: 0, actividades: [] };
    this.ejercicios.push(temp);

    this.selectedFiles = [];

    this.siPaso4();
    this.validarPasos();
    this.selecEjer(id);
  }

  agregarEjercicioInicializado(tipoI: number, actividaesI: any, idA: number) {
    console.log("🚀 ~ actividaesI:", actividaesI);
    let id = 0;
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        let temp_id = element.id;
        if (id < temp_id) {
          id = temp_id;
        }
      });
      id++;
    } else {
      id = 1;
    }
    let temp = {
      id: id,
      id_actividad: idA,
      active: false,
      tipo: tipoI,
      actividades: actividaesI,
    };
    console.log("🚀 ~ temp:", temp);
    this.ejercicios.push(temp);
    this.siPaso4();
    this.validarPasos();
    // this.selecEjer(id);
  }
  selecEjer(id) {
    console.log("🚀 ~ selecEjer ~ this.ejercicios:", this.ejercicios);
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        if (element.id == id) {
          this.ejercicioActivo = element.id;
          this.ejercicioActivoInfo = element;
          console.log(
            "🚀 ~ this.ejercicios.forEach ~ this.ejercicioActivoInfo:",
            this.ejercicioActivoInfo
          );
          element.active = true;
          this.ejercicioSelected = 1;
        } else {
          element.active = false;
        }
      });
    }

    if (this.modificacion == 2 || this.modificacion == 3) {
      this.bandera = 3;
      this.visualizacionEjercicio();
    }
  }

  //Visualización de los datos

  visualizacionEjercicio() {
    this.select_tipo_ejercicio =
      this.ejercicioActivoInfo.actividades.data.id_tipo;
    if (this.select_tipo_ejercicio == 1) {
      this.ejercicioActivoInfo.actividades.dataOp.forEach((opcion, i) => {
        if (opcion.vf == 1) {
          this.activeOption = i;
        }
      });
    }
    if (this.select_tipo_ejercicio == 4) {
      this.AcOrdenarTipo = this.ejercicioActivoInfo.actividades.data.tipo;
      this.ordenarExplicacion = "";

      if (this.AcOrdenarTipo == 1) {
        this.ordenarP.data = this.ejercicioActivoInfo.actividades.data;
        this.ordenarP.dataOp = this.ejercicioActivoInfo.actividades.dataOp;
      } else if (this.AcOrdenarTipo == 2) {
        this.ordenarS.data = this.ejercicioActivoInfo.actividades.data;
        this.ordenarS.dataOp = this.ejercicioActivoInfo.actividades.dataOp;
      }
    }

    if (this.select_tipo_ejercicio == 5) {
      // quita los duplicados por codigo y solo deja los que tiene recursos
      this.selectedFiles = Object.values(
        this.ejercicioActivoInfo.actividades.dataOp.reduce((acc, elem) => {
          if (acc[elem.code]) {
            if (!acc[elem.code].original && elem.original) {
              acc[elem.code] = elem.original;
            }
          } else {
            acc[elem.code] = elem.original;
          }
          return acc;
        }, {} as Record<string, string>)
      );
      this.memoriaInit();
    }

    if (this.select_tipo_ejercicio == 6) {
      this.palabras = [];
      this.ejercicioActivoInfo.actividades.dataOp.forEach((palabra) => {
        this.palabras.push({
          palabra: palabra.palabra,
          codigo: palabra.codigo,
          tipo: palabra.tipo,
        });
      });
      this.construirPuzzle();
      this.puzzleReorder();
      this.validarSopaLetras();
    }
    if (this.select_tipo_ejercicio == 7) {
      if (this.ejercicioActivoInfo.actividades.data.tipo_recurso != "img") {
        this.ejercicioActivoInfo.actividades.data.recurso = this.embedVideo(
          this.ejercicioActivoInfo.actividades.data.link_video
        );
      }
    }
  }

  getFileNameFromUrl(url: string): string {
    return url.split("/").pop() || "default_name";
  }

  eliminarEjercicio(i: number) {
    if (confirm("¿Deseas eliminar esta actividad?")) {
      this.ejercicios.splice(i, 1);
      this.actividadActual.activities = this.ejercicios;

      console.log("eliminado", this.actividadActual);
    }
  }

  agregarOpcionOMultiple() {
    let opcionOpM = {
      id: 0,
      id_activi_mult: this.ejercicioActivoInfo.actividades.data.id,
      opcion: "",
      recurso: null,
      file: null,
      tipo_recurso: "",
      vf: 0,
    };
    this.ejercicioActivoInfo.actividades.dataOp.push(opcionOpM);
    opcionOpM = this.dataOpcionM;
    this.opMultiVerificar();
  }

  agregarOpcionOrdenar(tipov: number) {
    if (tipov == 1) {
      let opcionOrdenarP = {
        id: 0,
        id_ordenar: this.ejercicioActivoInfo.actividades.data.id,
        tipo: tipov,
        input: "",
        recurso: null,
        file: null,
      };
      this.ordenarP.dataOp.push(opcionOrdenarP);
    } else {
      let opcionOrdenarS = {
        id: 0,
        id_ordenar: this.ejercicioActivoInfo.actividades.data.id,
        tipo: tipov,
        input: "",
        recurso: null,
        file: null,
      };
      this.ordenarS.dataOp.push(opcionOrdenarS);
    }
  }

  btn_guardar() {
    if (this.ejercicioActivoInfo.actividades.data.id_tipo == 5) {
      let dataPuzzle2 = [];
      this.memoriaArrayObj.forEach((elemX) => {
        elemX.x.forEach((elemY) => {
          let obj = {
            code: elemY.code,
            id: 0,
            id_memoria: 0,
            id_x: elemY.id,
            id_y: elemX.y,
            recurso: elemY.recursos,
            original: elemY.original,
            file: elemY.file,
          };
          dataPuzzle2.push(obj);
        });
      });
      this.ejercicioActivoInfo.actividades.dataOp = dataPuzzle2;
      this.ejercicioActivoInfo.actividades.delete =
        this.memoriaArrayDeleteItems;
      this.dataPuzzle = [];
      this.memObjFile = [];
      this.selectedFiles = [];
    }
    if (this.ejercicioActivoInfo.actividades.data.id_tipo == 6) {
      this.ejercicioActivoInfo.actividades.dataOp = JSON.parse(
        JSON.stringify(this.palabras)
      );
      this.palabras = [];
      this.bandera = 1;
    }
    console.log("ejercicios palabras:", this.ejercicioActivoInfo);
    this.ejerciciosModificados.push(this.ejercicioActivoInfo.id);
    this.actividadActualSinMod.activities.forEach((ejercicio, i) => {
      if (ejercicio.id == this.ejercicioActivoInfo.id) {
        this.actividadActualSinMod.activities[i] = this.ejercicioActivoInfo;
      }
    });
    console.log("Se guardó la modificación ..", this.actividadActual);
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
  }
  btn_cancelar() {
    if (confirm("¿Deseas descartar los cambios?")) {
      this.ejercicioActivoInfo = this.actividadActualSinMod.activities.find(
        (element) => element.id == this.ejercicioActivoInfo.id
      );

      this.actividadActual.activities.forEach((element, i) => {
        if (element.id == this.ejercicioActivoInfo.id) {
          this.actividadActual.activities[i] = this.ejercicioActivoInfo;
        }
      });
      console.log(
        "Se cancelaron las modificaciones de la actividad ...",
        this.actividadActual
      );
      this.ejercicioSelected = 0;
      this.select_tipo_ejercicio = 0;
    }
  }

  // Creacion

  btn_guardarC() {
    if (this.select_tipo_ejercicio == 4 || this.select_tipo_ejercicio == 9) {
      if (this.AcOrdenarTipo == 1) {
        this.ejercicios[this.ejercicios.length - 1].actividades.data =
          this.ordenarP.data;
        this.ejercicios[this.ejercicios.length - 1].actividades.dataOp =
          this.ordenarP.dataOp;
      } else {
        this.ejercicios[this.ejercicios.length - 1].actividades.data =
          this.ordenarS.data;
        this.ejercicios[this.ejercicios.length - 1].actividades.dataOp =
          this.ordenarS.dataOp;
      }
      this.ordenarS = JSON.parse(JSON.stringify(this.arregloOrdenar));
      this.ordenarP = JSON.parse(JSON.stringify(this.arregloOrdenar));
    }

    if (this.select_tipo_ejercicio == 5) {
      let dataPuzzle2 = [];
      this.memoriaArrayObj.forEach((elemX) => {
        elemX.x.forEach((elemY) => {
          let obj = {
            code: elemY.code,
            id: 0,
            id_memoria: 0,
            id_x: elemY.id,
            id_y: elemX.y,
            recurso: elemY.recursos,
            original: elemY.original,
            file: elemY.file,
          };
          dataPuzzle2.push(obj);
        });
      });
      this.ejercicios[this.ejercicios.length - 1].actividades.dataOp =
        dataPuzzle2;
      this.selectedFiles = [];
    }

    if (this.select_tipo_ejercicio == 6) {
      this.ejercicios[this.ejercicios.length - 1].actividades.dataOp =
        JSON.parse(JSON.stringify(this.palabras));
      this.palabras = [];
      this.bandera = 1;
    }

    // if (this.ejercicioActivoInfo.actividades.data.id_tipo == 7) {
    //   this.ejercicioActivoInfo.actividades.data.explicaciontema =
    //     this.claseExplicacion;
    //   this.ejercicioActivoInfo.actividades.data.link_video = this.urlVideo;
    //   this.ejercicioActivoInfo.actividades.data.explicacion =
    //     this.explicaciontemaExpl;
    //   this.ejercicioActivoInfo.actividades.data.image = this.fileImage;
    // }
    this.modificacion = 3;

    //Aca irian las validaciones de la creacion antes de guardar

    // this.actividadActualSinMod.activities.push(
    //   this.ejercicios[this.ejercicios.length - 1]
    // );
    console.log("Se guardó el nuevo ..", this.actividadActual);
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
  }
  btn_cancelarC() {
    if (confirm("¿Deseas descartar los cambios?")) {
      this.modificacion = 3;
      this.actividadActual.activities.pop(); //Elimino el ultimo registro creado
      console.log(
        "Se cancelaron las modificaciones de la actividad ...",
        this.actividadActual
      );
      this.ejercicioSelected = 0;
      this.select_tipo_ejercicio = 0;
    }
  }

  // ----------------------------------------

  eliminarRecursoPOP() {
    this.ejercicioActivoInfo.actividades.data.file = null;
    this.ejercicioActivoInfo.actividades.data.recurso = null;
    this.ejercicioActivoInfo.actividades.data.tipo_recurso = null;
  }

  eliminarRecursoOPop(id: number) {
    this.ejercicioActivoInfo.actividades.dataOp[id].recurso = null;
    this.ejercicioActivoInfo.actividades.dataOp[id].file = null;
    this.ejercicioActivoInfo.actividades.dataOp[id].tipo_recurso = null;
  }

  eliminarRecursoOpOrdenar(id: number, tipo: number) {
    if (tipo == 1) {
      this.ordenarP.dataOp[id].recurso = null;
    } else {
      this.ordenarS.dataOp[id].recurso = null;
    }

    this.validarOrdenar(tipo);
    // this.ejercicioActivoInfo.actividades.dataOp[id].recurso.file = null;
    // this.ejercicioActivoInfo.actividades.dataOp[id].recurso.b64 = null;
  }

  eliminarOpcionOM(id: number) {
    if (confirm("¿Deseas eliminar esta opción?")) {
      if (this.ejercicioActivoInfo.actividades.dataOp[id].vf == 1) {
        this.activeOption = null;
      }
      this.ejercicioActivoInfo.actividades.dataOp.splice(id, 1);
      this.opMultiVerificar();
    }
  }

  /********Core Ordenar************* */
  ordenarTipo(tipo) {
    this.AcOrdenarTipo = tipo;
    if (this.AcOrdenarTipo == 1) {
      this.validarOrdenar(1);
    } else if (this.AcOrdenarTipo == 2) {
      this.validarOrdenar(2);
      // this.paso3Active = false;
    }
  }

  ordenarVerificar() {}
  addPareja() {
    //ordenarArrayP:any = [{input:'',recurso:{b64:null,file:null}}];
    this.ordenarArrayP.push({
      tipo: 1,
      input: "",
      recurso: null,
      file: null,
    });
    console.log("ordenarArrayP: ", this.ordenarArrayP);
    this.validarOrdenarP();
  }

  addFileOrdenar(id) {
    let inputText: any = document.getElementById(id) as HTMLInputElement;
    inputText.click();
  }

  addFileOrdenarEv(event: EventTarget, id: number) {
    let evento: any = event;
    let idele = evento.target.id;
    let idbox = idele + "-box";
    let data = evento.target.dataset.pos;
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        let b64 = fr.result;
        _this.ordenarP.dataOp[id].file = file;
        _this.ordenarP.dataOp[id].recurso = b64;
        _this.validarOrdenar(1);
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }
  addFileOrdenarSec(id) {
    let inputText: any = document.getElementById(id) as HTMLInputElement;
    inputText.click();
  }
  addFileOrdenarSecEv(event: EventTarget, id: number) {
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        let b64 = fr.result;
        _this.ordenarS.dataOp[id].file = file;
        _this.ordenarS.dataOp[id].recurso = b64;

        _this.validarOrdenar(2);
      };
      fr.readAsDataURL(file);
    }
    console.log("🚀 ~ addFileOrdenarSecEv ~ this.ordenarS:", this.ordenarS);
  }
  deleteOrdenar(i) {
    if (confirm("¿Deseas eliminar esta opción?")) {
      if (this.ordenarP.dataOp.length > 1) {
        this.ordenarP.dataOp.splice(i, 1);
        this.validarOrdenar(1);
      }
    }
  }

  validarOrdenar(tipo: number) {
    let valid = true;
    console.log("🚀 ~ validarOrdenar ~ tipo:", tipo);
    if (tipo == 1) {
      if (this.ordenarP.dataOp.length < 2) {
        valid = false;
        this.paso3Active = valid;
        this.validoGuardar = valid;
        this.validoCrear = valid;
        return;
      }

      this.ordenarP.dataOp.forEach((element, index) => {
        let input = element.input;

        if (element.recurso == null) {
          valid = false;
        }
        if (input == null) {
          valid = false;
        } else {
          // if (!this.validInput(input)) {
          //   valid = false;
          // }
        }
        // if (index == (this.ordenarArrayS.length - 1)) {
        //   //
        //   let input2 = this.ejercicioActivoInfo.actividades.data.explicacion;
        //   // if (!this.validInput(input2)) {
        //   //   valid = false;
        //   //   this.paso3Active = valid;
        //   // } else {
        //   //   this.paso3Active = valid;
        //   // }
        // }
      });

      this.validoGuardar = valid;
      this.validoCrear = valid;
    } else if (tipo == 2) {
      if (this.ordenarS.dataOp.length < 2) {
        valid = false;
        this.paso3Active = valid;
        this.validoGuardar = valid;
        this.validoCrear = valid;
        return;
      }

      this.ordenarS.dataOp.forEach((element, index) => {
        let input = element.input;
        if (input == null) {
          valid = false;
        } else {
          // if (!this.validInput(input)) {
          //   valid = false;
          // }
        }
        // if (index == (this.ordenarArrayS.length - 1)) {
        //   //
        //   let input2 = this.ejercicioActivoInfo.actividades.data.explicacion;
        //   // if (!this.validInput(input2)) {
        //   //   valid = false;
        //   //   this.paso3Active = valid;
        //   // } else {
        //   //   this.paso3Active = valid;
        //   // }
        // }
      });

      this.validoGuardar = valid;
      this.validoCrear = valid;
    }
  }

  deleteOrdenarSec(i) {
    if (confirm("¿Deseas eliminar esta opción?")) {
      this.ordenarS.dataOp.splice(i, 1);

      // this.ejercicioActivoInfo.actividades.dataOp.splice(i, 1);
      this.validarOrdenar(2);
    }
  }
  async deleteAlertSec() {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: "No se puede eliminar este elemento",
      buttons: ["Aceptar"],
    });

    await alert.present();
  }

  //const alert = await this.alertController.create({
  async saveAllMsg(message) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: message,
      buttons: [
        {
          text: "Aceptar",
          handler: () => {},
        },
      ],
    });
    await alert.present();
    await alert.onDidDismiss().then((data) => {
      if (this.reload) {
        //window.location.reload();
        this.dataService.setData([
          {
            curso: this.curso.id,
            data: [{ crearCurso: true, opcion: 1 }],
          },
        ]);
      } else {
        this.reload = true;
      }
    });
  }
  async deleteAlert() {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: "No se puede eliminar este elemento",
      buttons: ["Aceptar"],
    });

    await alert.present();
  }
  validarOrdenarPBK() {
    let valid = true;
    if (this.ordenarArrayP.length < 2) {
      valid = false;
      this.paso3Active = valid;
      return;
    }
    this.ordenarArrayP.forEach((element, index) => {
      let input: any = document.getElementById(
        "pareja-input-" + index
      ) as HTMLInputElement;

      if (element.recurso.file == null) {
        valid = false;
      }
      if (input == null) {
        valid = false;
      } else if (!this.validInput(input)) {
        valid = false;
      }
      if (index == this.ordenarArrayP.length - 1) {
        //
        let input2: any = document.getElementById(
          "ordenarExplicacion"
        ) as HTMLInputElement;
        if (!this.validInput(input2)) {
          valid = false;
          this.paso3Active = valid;
        } else {
          this.paso3Active = valid;
        }
      }
    });
  }
  validarOrdenarP() {
    let valid = true;
    if (this.ejercicioActivoInfo.actividades.dataOp.length < 2) {
      valid = false;
      this.paso3Active = valid;
      this.validoCrear = valid;
      this.validoGuardar = valid;
      return;
    }
    this.ejercicioActivoInfo.actividades.dataOp.forEach((element, index) => {
      let input = element.input;

      if (element.recurso.file == null) {
        valid = false;
      }
      if (input == null) {
        valid = false;
      } else {
        // if (!this.validInput(input)) {
        //   valid = false;
        // }
      }

      if (index == this.ejercicioActivoInfo.actividades.dataOp - 1) {
        //
        let input2 = this.ejercicioActivoInfo.actividades.data.explicacion;
        // if (!this.validInput(input2)) {
        //   valid = false;
        //   this.paso3Active = valid;
        // } else {
        //   this.paso3Active = valid;
        // }
      }
    });

    console.log("estefaniaaaa", valid);

    this.validoGuardar = valid;
    this.validoCrear = valid;
  }

  resetOrdenar() {
    this.ordenarArrayP = [{ tipo: 1, input: "", recurso: null, file: null }];
    this.ordenarArrayS = [{ tipo: 2, input: "", recurso: null, file: null }];
  }
  /********Fin Ordenar************ */

  /********Core Memoria************* */

  memoriaInitC() {
    //memoriaArrayObj
    return new Promise((resolve) => {
      this.memoriaArrayObj = [];
      this.memoriaArray = [];
      for (let i = 0; i < this.memoriaSize.y; i++) {
        let idY = this.pad(i, 2);
        this.memoriaArrayObj.push({ y: idY, x: [] });
        for (let j = 0; j < this.memoriaSize.x; j++) {
          let idX = this.pad(j, 2);
          this.memObjItems.push("y" + idY + "_x" + idX);
          this.memoriaArrayObj[i].x.push({
            id: "y" + idY + "_x" + idX,
            code: "",
            recursos: "",
            original: "",
            file: null,
          });
        }
        if (i == this.memoriaSize.y - 1) {
          resolve(true);
        }
      }
    });
  }

  memoriaInit() {
    // Calcula el total de cuadrículas (el doble del número de imágenes)
    let totalCuadriculas = this.selectedFiles.length * 2;
    // Calcula el número de cuadrículas de ancho y alto (divisores más cercanos al cuadrado del total de cuadrículas)
    let numCuadriculasAncho = Math.ceil(Math.sqrt(totalCuadriculas));
    let numCuadriculasAlto = Math.ceil(totalCuadriculas / numCuadriculasAncho);
    return new Promise((resolve) => {
      this.memoriaArrayObj = [];
      this.memObjFile = [];
      this.memoriaArray = [];
      let currentCuadricula = 0;
      for (let i = 0; i < numCuadriculasAlto; i++) {
        let idY = this.pad(i, 2);
        this.memoriaArrayObj.push({ y: idY, x: [] });
        for (let j = 0; j < numCuadriculasAncho; j++) {
          if (currentCuadricula < totalCuadriculas) {
            let idX = this.pad(j, 2);
            this.memObjItems.push("y" + idY + "_x" + idX);
            this.memoriaArrayObj[i].x.push({
              id: "y" + idY + "_x" + idX,
              code: "",
              recursos: "",
              original: "",
              file: null,
            });
            currentCuadricula++;
          }
        }
      }
      this.addFileMemoriaEv();
      resolve(true);
    });
  }

  addPuzzleMem() {
    let flag = this.memoriaArray.length - 1;
    if (this.memObjItems.length == 0) {
      return;
    }
    let recursos = this.memoriaArray[flag].recursos;
    let file = this.memoriaArray[flag].file;
    let name = this.memoriaArray[flag].name;
    let original = this.memoriaArray[flag].original;
    let code = "";
    let item = "";
    let item2 = "";
    code = this.generateUUID();
    let m = new Promise((resolve) => {
      let i = Math.floor(Math.random() * this.memObjItems.length + 0);
      item = this.memObjItems[i];
      this.memoriaArrayObj.forEach((element, index, array) => {
        element.x.forEach((elementX) => {
          if (elementX.id == item) {
            this.memObjItems.splice(i, 1);
            elementX.recursos = recursos;
            elementX.file = file;
            elementX.code = code;
            elementX.original = original;
          }
          if (index == array.length - 1) {
            resolve(true);
          }
        });
      });
    });
    m.then((insert) => {
      let j = Math.floor(Math.random() * this.memObjItems.length + 0);
      //this.memoriaArrayObj[i].x.push({id:('y'+idY+'_x'+idX),recursos:{b64:null,file:null}});
      item2 = this.memObjItems[j];
      this.memoriaArrayObj.forEach((element, index, array) => {
        element.x.forEach((elementX) => {
          if (elementX.id == item2) {
            elementX.recursos = recursos;
            elementX.file = file;
            elementX.code = code;
            elementX.name = name;
            elementX.original = original;
            this.memObjFile.push({
              code: code,
              recursos: recursos,
              name: name,
              original: original,
            });
            this.memObjItems.splice(j, 1);
          }
          if (index == array.length - 1) {
            this.validarMemoria();
          }
        });
      });
    });
  }

  resetMemoria() {
    this.data_Memoria = [];
    this.memoriaArray = [];
    this.memoriaArrayObj = [];
    this.memoriaSize = [{ x: 6, y: 6 }];
  }
  addMemImg() {
    let inputText: any = document.getElementById(
      "img-memoria-input"
    ) as HTMLInputElement;
    inputText.click();
  }
  editFileMemoria(item) {
    this.itemEditMem = item;
    let inputText: any = document.getElementById(
      "img-memoria-input-edit"
    ) as HTMLInputElement;
    inputText.click();
  }

  editFileMemoriaEv(event: EventTarget) {
    console.log("this.itemEditMem: ", this.itemEditMem);
    let code = this.itemEditMem.code;
    let evento: any = event;
    let idele = evento.target.id;
    let idbox = idele + "-box";
    let data = evento.target.dataset.pos;
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        let b64 = fr.result;
        //this.memoriaArrayObj[i].x.push({id:('y'+idY+'_x'+idX),code:'',recursos:{b64:null,file:null}});
        _this.memoriaArrayObj.forEach((element) => {
          element.x.forEach((elementX) => {
            // console.log("E", elementX.code, code);
            if (elementX.code == code) {
              elementX.recursos.file = file;
              elementX.recursos.b64 = b64;
              _this.itemEditMem.b64 = b64;

              _this.memObjFile.forEach((mem) => {
                if (mem.code == code) {
                  mem.recurso.file = file;
                  mem.recurso.b64 = b64;
                }
              });
            }
          });
        });

        //_this.addPuzzleMem();
        //_this.validarMemoria();
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();

      console.log("sandia", this.memoriaArrayObj);
    }
  }
  addFileMemoriaEv() {
    this.selectedFiles.forEach((file) => {
      let _this = this;
      if (FileReader && file instanceof File) {
        var fr = new FileReader();
        fr.onload = function () {
          //{tipo:'',value:'',object:null,b64:''};
          let b64 = fr.result;
          _this.memoriaArray.push({
            recursos: b64,
            file: file,
            name: file.name,
          });
          _this.addPuzzleMem();
        };
        fr.readAsDataURL(file);
        //this.closeFileAdd();
      } else {
        _this.memoriaArray.push({
          recursos: this.host + file,
          original: file,
          file: null,
          name: null,
        });
        _this.addPuzzleMem();
      }
    });
  }
  validarMemoria() {
    if (this.memObjFile.length == 0) {
      this.validoGuardar = false;
      this.validoCrear = false;
      this.paso3Active = true;
    } else if (this.memObjFile.length > 2) {
      this.validoGuardar = true;
      this.validoCrear = true;
      this.paso3Active = false;
    }
  }

  /********Fin Core Memoria************* */

  /********Core Sopa de Letras***** */

  initMatriz() {
    return new Promise((resolve) => {
      for (let i = 0; i < this.puzzleMin.y; i++) {
        let idY = this.pad(i, 2);
        this.puzzleObj.push({ idY: idY, idX: [] });
        for (let j = 0; j < this.puzzleMin.x; j++) {
          let idX = this.pad(j, 2);
          this.puzzleObj[i].idX.push(idX);
        }
        if (i == this.puzzleMin.y - 1) {
          resolve(true);
        }
      }
    });
  }

  posiciones: any = [
    "horizontal",
    "horizontalR",
    "vertical",
    "verticalR",
    "diagonalD",
    "diagonalDR",
    "diagonalU",
    "diagonalUR",
  ];

  rezise = false;
  resizePuzle(texto = null) {
    let add = 0;
    let tamano = 0;
    let tamano1 = 0;
    tamano = this.palabras.length;
    if (texto) {
      tamano1 = texto.length;
    } else {
      this.palabras.forEach((element) => {
        if (element.palabra.length > tamano) {
          tamano = element.palabra.length;
        }
      });
    }
    if (tamano1 > tamano) {
      tamano = tamano1;
    }
    if (tamano < this.puzzleMax) {
      tamano++;
    }

    if (this.puzzleMin.y > tamano) {
      tamano = this.puzzleMin.y;
    }

    this.puzzleMin.y = tamano;
    this.puzzleMin.x = tamano;
    if (this.puzzleMin.y > this.puzzleMax) {
      this.puzzleMin.y = this.puzzleMax;
      this.puzzleMin.x = this.puzzleMax;
    }
    this.puzzleObj = [];
    let palabras: any = this.palabras;
    this.palabras = [];
    if (texto) palabras.push({ palabra: texto });

    let m = new Promise((resolve) => {
      console.log("aumentando la matriz...");
      this.initMatriz().then((insert) => {
        setTimeout(() => {
          resolve(true);
        }, 200);
      });
    });
    console.log("");
    //this.palabras.push({palabra:texto,codigo:codigo,tipo:this.posiciones[1]});
    m.then((insert) => {
      this.palabraInput = "";
      console.log("matriz aumentada...");
      this.rezise = true;
      palabras.forEach((element) => {
        //console.log('palabras: ',palabras);

        setTimeout(() => {
          this.addText(element.palabra).then((value) => {
            console.log(`promise result: ${value}`);
            //Storage
            this.rezise = false;
          });
        }, 10);
      });
    });
  }

  puzzleReorder() {
    //  this.puzzleObjData = [];
    if (this.palabras.length >= 0) {
      this.bandera = 2;
      this.resizePuzle();
    }
  }
  eventHandlerPuzzle(keyCode) {
    if (keyCode == 13) {
      this.addText();
    }
  }
  puzzleIntentos = 0;
  lastPosition: number = -1;

  addText(resizeText = null) {
    this.bandera = 2;
    return new Promise((resolve) => {
      this.puzzleIntentos++;
      console.log("insertanto palabra: ", this.puzzleIntentos);
      if (this.puzzleIntentos > 1500) {
        alert(
          'Se han sobrepasado los intentos de insertar la palabra: "' +
            this.palabraInput +
            '"' +
            ""
        );
        this.puzzleIntentos = 0;
        resolve(false);
        return;
      }
      console.log("resizeText: ", resizeText);

      let texto = "";
      if (resizeText == null) {
        texto = this.palabraInput;
      } else {
        texto = resizeText;
      }
      if (resizeText == null) {
        texto = this.palabraInput;
        if (!this.puzzleVerificarLimite(texto) && resizeText == null) {
          this.palabraInput = "";
          return;
        }

        let maxLen1 = this.palabras.length;
        let maxLen2 = this.puzzleMin.y;
        let maxLen = maxLen2;
        if (maxLen1 > maxLen2) {
          maxLen = maxLen1;
        }

        if (
          (maxLen >= this.puzzleMin.y &&
            this.puzzleMin.y < this.puzzleMax &&
            texto.length >= maxLen) ||
          (maxLen1 >= this.puzzleMin.y && this.puzzleMin.y < this.puzzleMax)
        ) {
          console.log(
            "resizeText - Resize Puzle 1... resizeText: ",
            resizeText
          );

          this.resizePuzle(texto);
          return;
        }
      }
      let max = this.posiciones.length;
      let min = 0;
      let r = Math.floor(Math.random() * (max - 0 + 1) + min);

      console.log("random: " + r);
      //this._horizontal(texto);

      if (this.lastPosition >= -1) {
        r = Math.floor(Math.random() * (2 - 1 + 1) + min);
      } else {
      }
      r = Math.floor(Math.random() * (5 - 1 + 1) + min);
      console.log("Random result r: ", r);
      setTimeout(() => {
        if (r == 0)
          this._horizontal(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_horizontal Selected: ${value}`);
            resolve(value);
          }); /** */
        if (r == 1)
          this._horizontalR(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_horizontalR Selected: ${value}`);
            resolve(value);
          }); /** */
        if (r == 2)
          this._vertical(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_vertical Selected: ${value}`);
            resolve(value);
          });
        if (r == 3)
          this._verticalR(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_verticalR Selected: ${value}`);
            resolve(value);
          });
        if (r == 4)
          this._diagonalD(texto).then((value) => {
            this.lastPosition = r;
            console.log(`_diagonalD Selected: ${value}`);
            resolve(value);
          });
      }, 50);
    });
  }

  ngAfterViewInit() {
    let _this = this;
    $(document).ready(function () {});
  }
  mousedown(id) {
    let _this = $("#" + id);
    this.flagOpen = "";
    let flagClosed = "";
    this.word = "";
    this.flagOpenTemp = "";
    this.flagOpen = $(_this).attr("id");
    if (this.word == "") this.word = $.trim($(_this).text());
    this.flagOpenTemp = this.flagOpen;
    console.log("Open: ", this.flagOpen);
    $(".p-caja").removeClass("selected");
  }
  mouseup(id) {
    if (this.flagOpen != "") {
      this.flagClosed = "";
      this.flagClosed = $("#" + id).attr("id");
      console.log("close: ", this.flagClosed);
      let open = this.flagOpen.split("_");
      let openR = parseInt(open[0].replace("r", ""));
      let openC = parseInt(open[1].replace("c", ""));

      let close = this.flagClosed.split("_");
      let closeR = parseInt(close[0].replace("r", ""));
      let closeC = parseInt(close[1].replace("c", ""));
      console.log("Word: ", this.word);
      console.log("codigos: ", this.codigos);
      this.codigos = [];
      $(".p-caja").removeClass("selected");
      this.flagOpen = "";
      this.flagOpenTemp = "";
      this.flagClosed = "";
      if (this.word != "") {
        this.word = "";
      }
    }
  }
  mouseover(id) {
    if (this.flagOpen != "") {
      if (!this.diagonalDU("#" + id)) {
        if (!this.diagonalUD("#" + id)) {
          if (!this.horizontalNormal("#" + id)) {
            this.verticarNormal("#" + id);
          }
        }
      }
    }
  }
  diagonalDU(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let r1 = r - openR;
    let c1 = openC + r1;
    //console.log('r1: ' + r1 + ' / c1: ' + c1);
    this.word = "";
    if (c1 == c) {
      if (r1 < 0) {
        console.log("Diagonal inversa");
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1 * -1; i++) {
          let clase =
            "#r" + this.pad(openR - i, 2) + "_c" + this.pad(openC - i, 2);
          //console.log(clase);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      } else {
        //console.log('Diagonal normal');
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1; i++) {
          let clase =
            "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    } else {
      return false;
    }
  }
  diagonalUD(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let c1 = c - openC;
    let r1 = openR - r;
    if (c1 == r1) {
      if (c1 < 0) {
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1 * -1; i++) {
          let clase =
            "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC - i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      } else {
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1; i++) {
          let clase =
            "#r" + this.pad(openR - i, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    } else {
      return false;
    }
  }
  horizontalNormal(element) {
    let str = $(element).attr("id");
    let res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let r1 = r - openR;
    let c1 = c;
    if (openR == r) {
      if (openC < c) {
        console.log("horizontalNormal");
        this.word = "";
        this.codigos = [];
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= c - openC; i++) {
          let clase = "#r" + this.pad(openR, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      } else {
        console.log("horizontal reversa");
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = openC; i >= c1; i--) {
          let clase = "#r" + this.pad(openR, 2) + "_c" + this.pad(i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    }
    return false;
  }
  verticarNormal(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    //console.log( 'openR: ' + (openR) + ' | openC: ' + (openC) );
    let r1 = r - openR;
    let c1 = c;
    console.log("r: " + r + " / c: " + c1);
    if (openC == c) {
      if (openR < r) {
        console.log("Vertical normal");
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r - openR; i++) {
          let clase = "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
          console.log("Clase v: ", i);
        }
      } else {
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        console.log("Vertical reverso");
        $(".p-caja").removeClass("selected");
        for (let i = openR; i >= r; i--) {
          let clase = "#r" + this.pad(i, 2) + "_c" + this.pad(openC, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.word += $.trim($(clase).text());
        }
      }
    }
  }
  puzzleVerificarLimite(texto) {
    let retorno: boolean = true;
    let input: any = document.getElementById("text-puzzle") as HTMLInputElement;
    if (!this.validInput(input, false)) {
      alert(
        "¡Formato invalido! El campo debe contener entre 3 y 10 caracteres. Solo se permiten letras, incluidas mayúsculas, minúsculas y letras con acentos (como á, é, í, ó, ú, ñ, ü). No se permiten números, espacios ni caracteres especiales."
      );
      return false;
    }

    let max = this.puzzleMin.y;
    if (this.palabras.length >= this.puzzleMax) {
      alert("Ha llegado al límite de palabras");
      return false;
    }
    if (texto.length > this.puzzleMax) {
      alert("La palabra es muy larga");
      return false;
    }
    this.palabras.forEach((element) => {
      if (element.palabra == texto) {
        retorno = false;
        alert("¡La palabra ya existe!");
      }
    });
    return retorno;
  }

  puzzleVerificarLimite2(texto) {
    let retorno: boolean = true;
    this.palabras.forEach((element) => {
      if (element.palabra == texto) {
        retorno = false;
        alert("¡La palabra ya existe!");
      }
    });
    return retorno;
  }
  /**********Random Horizontal */
  _horizontal(texto) {
    return new Promise((resolve) => {
      let tipo: number = 0;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;

      let min = 0;
      let textlen = texto.length;
      let r = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);

      let p = max - textlen;
      console.log("texto: " + texto);
      console.log("random: " + max);
      console.log("p: " + p);
      let pr = Math.floor(Math.random() * (p - 0 + 1) + min);
      console.log("pr: " + pr);
      let t = 0;
      let _this = this;
      let x = 0;
      let tf = 0;
      let insert = true;
      let coincidencia = 0;

      let bar = new Promise((resolve2, reject) => {
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach((elementX) => {
            let clase = "r" + value.idY + "_c" + elementX;
            let elem: any = document.getElementById(clase) as HTMLInputElement;
            if (
              _this.pad(r, 2) == value.idY &&
              _this.pad(pr + x, 2) == elementX &&
              x < textlen
            ) {
              console.log("coincidencia: r" + value.idY + "_c" + elementX);
              console.log(
                "Caracter: " +
                  elem.innerText +
                  ", texto[" +
                  x +
                  "]: " +
                  texto[x]
              );
              if (elem.innerText && texto[x] != undefined) {
                if (elem.innerText != texto[x]) {
                  insert = false;
                }
              }
              x++;
            }
          });
          if (index === array.length - 1) {
            resolve2(insert);
          }
        });
      });
      let codigo = "";
      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          for (let i = p; i < max; i++) {
            let clase = "#r" + _this.pad(r, 2) + "_c" + _this.pad(pr + t, 2);
            let duplic = 0;
            codigo += clase + ",";
            $(clase).text(texto[t]);
            t++;
            console.log("Clase: ", clase + " - " + p);
            if (i == max - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.validarSopaLetras();
              this.palabraInput = "";
              console.log("palabras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(true);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontal(texto);
        }
      });
    });
  }
  _horizontalR(texto) {
    return new Promise((resolve) => {
      let res = true;
      let tipo: number = 1;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;

      let min = 0;
      let textlen = texto.length;
      let fila = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);
      let flen = max - textlen;
      let columna = Math.floor(Math.random() * (flen - 1 - 0 + 1) + min);
      let t = 0;
      let resultX = true;
      let _this = this;
      let x = 0;
      let tf = textlen - 1;
      let insert = true;
      let coincidencia = 0;
      tf = textlen - 1;
      let bar = new Promise((resolve2, reject) => {
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          x = 0;
          casillas.forEach(function (elementX) {
            if (value.idY == _this.pad(fila, 2)) {
              if (_this.pad(columna + x, 2) == elementX) {
                let id = "r" + value.idY + "_c" + elementX;
                console.log("id: " + texto[tf] + ": " + id);
                let elem: any = document.getElementById(id) as HTMLInputElement;
                x++;
                if (x >= textlen) {
                  x = 0;
                }
                try {
                  if (elem.innerText) {
                    console.log(
                      "id2: " + texto[tf] + ": " + id + ", tf: " + tf
                    );
                    if (tf >= 0) {
                      if (texto[tf] != elem.innerText) {
                        console.log(
                          "texto[tf]: " +
                            texto[tf] +
                            ", elem.innerText: " +
                            elem.innerText
                        );
                        resultX = false;
                      } else {
                        console.log(
                          "Igual: texto[tf]: " +
                            texto[tf] +
                            ", elem.innerText: " +
                            elem.innerText
                        );
                      }
                    }
                  } else {
                  }
                } catch (error) {}
                tf--;
              }
            }
          });
          if (index === array.length - 1) {
            resolve2(resultX);
          }
        });
      });

      let codigo = "";
      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          let t = texto.length - 1;
          let x = 0;
          for (let i = 0; i < textlen; i++) {
            let clase =
              "#r" + _this.pad(fila, 2) + "_c" + _this.pad(columna + i, 2);
            let duplic = 0;
            codigo += clase + ",";
            $(clase).text(texto[t]);
            t--;

            //console.log('Clase: ',clase + ' - ' + i);
            if (i == texto.length - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.validarSopaLetras();
              this.palabraInput = "";
              console.log("palabras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(insert);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontalR(texto);
        }
      });
    });
  }
  /**********Fin random Hirozontal */
  /**********Random Vertical */
  _vertical(texto) {
    console.log("Texto vertical: ", texto);
    return new Promise((resolve) => {
      let result = true;
      let tipo: number = 2;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;
      let _this = this;
      let min = 0;
      let textlen = texto.length;
      let columna = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);
      let vlen = max - textlen;

      let vertical = Math.floor(Math.random() * (vlen - 1 - 0 + 1) + min);
      console.log(
        "Vertical columna selected: " + columna + ", vertical: " + vertical
      );
      //console.log('columna: '+columna+', vertical: '+vertical);

      let resultX = true;
      let bar = new Promise((resolve2, reject) => {
        let v = 0;
        let t = 0;
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach(function (elementX) {
            if (_this.pad(columna, 2) == elementX) {
              console.log(
                "Vertical elementX:" + elementX + ", value.idY:" + value.idY
              );
              if (_this.pad(vertical + v, 2) == value.idY) {
                console.log("Vertical value.idY:" + value.idY + "");
                console.log(
                  "vertical y: " +
                    value.idY +
                    ", columna: " +
                    _this.pad(columna, 2)
                );
                let id =
                  "r" + _this.pad(value.idY, 2) + "_c" + _this.pad(columna, 2);
                let elem: any = document.getElementById(id) as HTMLInputElement;
                if (elem.innerText) {
                  console.log(
                    "Vertical: if(" + elem.innerText + " == " + texto[v] + ")"
                  );
                  if (v < textlen) {
                    if (texto[v] != elem.innerText) {
                      console.log("False");
                      resultX = false;
                    } else {
                      ("True");
                    }
                  }
                  t++;
                } else {
                  t = 0;
                }
                v++;
              }
              //v++;
            }
          });
          if (index === array.length - 1) {
            resolve2(resultX);
          }
        });
      });
      let codigo = "";

      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          let t = texto.length - 1;
          let x = 0;
          for (let i = vertical; i < max; i++) {
            //for (let i = vertical; i < (max); i++) {
            let clase = "#r" + _this.pad(i, 2) + "_c" + _this.pad(columna, 2);
            let duplic = 0;
            if (x < textlen) {
              codigo += clase + ",";
              $(clase).text(texto[x]);
            }

            x++;

            console.log("Clase: ", clase + " - " + i);
            if (i == max - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.validarSopaLetras();
              this.palabraInput = "";
              console.log("palbras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(result);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontalR(texto);
        }
      });
    });
  }
  /**********Fin random Vertical */

  _verticalR(texto) {
    return new Promise((resolve) => {
      let result = true;
      let tipo: number = 3;
      texto = texto.toLowerCase();
      let max = this.puzzleMin.y;
      let _this = this;
      let min = 0;
      let textlen = texto.length;
      let columna = Math.floor(Math.random() * (max - 1 - 0 + 1) + min);
      let vlen = max - textlen;

      let vertical = Math.floor(Math.random() * (vlen - 1 - 0 + 1) + min);
      let resultX = true;
      let bar = new Promise((resolve2, reject) => {
        let v = 0;
        let t = textlen - 1;
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach(function (elementX) {
            if (_this.pad(columna, 2) == elementX) {
              //console.log('VerticalR elementX:'+elementX+', value.idY:'+value.idY);
              if (_this.pad(vertical + v, 2) == value.idY) {
                console.log("VerticalR value.idY:" + value.idY + "");

                let id =
                  "r" + _this.pad(value.idY, 2) + "_c" + _this.pad(columna, 2);
                let elem: any = document.getElementById(id) as HTMLInputElement;
                if (elem.innerText) {
                  console.log(
                    "verticalR y: " +
                      value.idY +
                      ", columna: " +
                      _this.pad(columna, 2)
                  );
                  console.log(
                    "VerticalR: if(" + elem.innerText + " == " + texto[t] + ")"
                  );
                  if (t >= 0) {
                    if (texto[t] != elem.innerText) {
                      console.log("False");
                      resultX = false;
                    }
                  }
                } else {
                  //t=0;
                }
                t--;
                v++;
              }
              //v++;
            }
          });
          if (index === array.length - 1) {
            resolve2(resultX);
          }
        });
      });
      let codigo = "";

      bar.then((insert) => {
        console.log("All done!", insert);
        if (insert) {
          let t = texto.length - 1;
          let x = 0;
          for (let i = vertical; i < max; i++) {
            let clase = "#r" + _this.pad(i, 2) + "_c" + _this.pad(columna, 2);
            let duplic = 0;
            //codigo += clase+',';
            //$(clase).text(texto[t]);
            if (x < textlen) {
              codigo += clase + ",";
              $(clase).text(texto[x]);
            }
            x++;
            t--;
            console.log("Clase: ", clase + " - " + i);
            if (i == max - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.validarSopaLetras();
              this.palabraInput = "";
              console.log("palbras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(result);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
          //this._horizontalR(texto);
        }
      });
    });
  }
  /**********Fin random Vertical */
  /**************Diagonales***** _diagonalD */
  _diagonalD(texto) {
    return new Promise((resolve) => {
      texto = texto.toLowerCase();
      let tipo: number = 4;
      let max = this.puzzleMin.y;
      let _this = this;
      let min = 0;
      let textlen = texto.length;

      let textolen = max - textlen;

      let xy = Math.floor(Math.random() * (2 - 1 + 1) + min);
      let x = 0;
      let y = 0;
      let random1 = Math.floor(Math.random() * (textolen - 0 + 1) + min);
      let random2 = Math.floor(Math.random() * (textolen - 0 + 1) + min);
      if (xy == 0) {
        x = random1;
        y = random2;
      } else {
        y = random1;
        x = random2;
      }
      let next = 0;
      let result = true;

      let bar = new Promise((resolve2, reject) => {
        this.puzzleObj.forEach((value, index, array) => {
          let casillas: any = value.idX;
          casillas.forEach(function (elementX) {
            if (
              value.idY == _this.pad(y + next, 2) &&
              _this.pad(x + next, 2) == elementX
            ) {
              let id = "r" + value.idY + "_c" + elementX;
              console.log("_diagonalD id: " + id);
              let elem: any = document.getElementById(id) as HTMLInputElement;
              if (elem.innerText && texto[next] != undefined) {
                if (texto[next] != elem.innerText) {
                  result = false;
                }
              }
              next++;
            }
          });

          if (index === array.length - 1) {
            resolve2(result);
          }
        });
      });
      let codigo = "";
      bar.then((insert) => {
        if (insert) {
          let next = 0;
          for (let i = 0; i < textlen; i++) {
            let id =
              "#r" + _this.pad(y + next, 2) + "_c" + _this.pad(x + next, 2);
            $(id).text(texto[i]);
            next++;
            codigo += id + ",";
            if (i == textlen - 1) {
              codigo = codigo.replace(/,\s*$/, "");
              this.palabras.push({
                palabra: texto,
                codigo: codigo,
                tipo: this.posiciones[tipo],
              });
              this.validarSopaLetras();
              this.palabraInput = "";
              console.log("palbras: ", this.palabras);
              console.log("this.puzzleIntentos: ", this.puzzleIntentos);
              this.puzzleIntentos = 0;
              if (this.palabras.length > 1) {
                this.paso3Active = true;
              } else {
                this.paso3Active = false;
              }
              resolve(insert);
            }
          }
        } else {
          this.addText(texto).then((insert) => {
            resolve(false);
          });
        }
      });
    });
  }
  /**************Fin Diagonales***** _diagonalD */
  pad(str, max) {
    str = str.toString();
    return str.length < max ? this.pad("0" + str, max) : str;
  }
  /****Fin Core Sopa de letras */
  addPiece() {
    this.countopcion++;
    let arr: any = this.ionicForm.value;
    let index = arr.opcion.length;

    const opcion = this.formBuilder.group({
      id: [this.countopcion, [Validators.required, Validators.minLength(1)]],
      ["respuesta"]: [
        "",
        [
          Validators.required,
          Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
        ],
      ],
      ["verdadero" + index]: [this.countopcion, [Validators.required]],
    });
    this.getPiecesArray.push(opcion);
    console.log("After Add: ", this.ionicForm.value);
    setTimeout(() => {
      this.opMultiVerificar();
    }, 250);
  }

  addPieceM(respuesta: string, vf: boolean) {
    this.countopcion++;
    let arr: any = this.ionicForm.value;
    let index = arr.opcion.length;

    const opcion = this.formBuilder.group({
      id: [this.countopcion, [Validators.required, Validators.minLength(1)]],
      ["respuesta"]: [
        respuesta,
        [
          Validators.required,
          Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
        ],
      ],
      ["verdadero" + index]: [vf, [Validators.required]],
    });
    this.getPiecesArray.push(opcion);
    // console.log('After Add: ', this.ionicForm.value);
    setTimeout(() => {
      this.opMultiVerificar();
    }, 250);
  }

  onSubmitForm() {
    console.log(this.ionicForm.value);
  }
  eventHandler(keyCode) {
    if (keyCode == 13) {
      console.log(this.ionicForm.value);

      if (this.ionicForm.valid) {
        console.log("Submit...");
      }
    }
  }

  deleteOp(i, id_file) {
    let index = 0;
    this.array_option_imgs.forEach((element) => {
      if (element.id == id_file) {
        this.array_option_imgs.splice(index, 1);
      }
      index++;
    });
    this.activeOption = 0;
    this.getPiecesArray.removeAt(i);
    //recorrer array de imagenes y verificar
    let controls: any = this.ionicForm.controls.opcion;
    controls.controls.forEach((element) => {
      element.controls.respuesta.setValidators([
        Validators.required,
        Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
      ]);
      element.controls.respuesta.updateValueAndValidity();
      this.array_option_imgs.forEach((elementIMG) => {
        if (element.controls.id.value == elementIMG.id) {
          element.controls.respuesta.setValidators([
            Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
          ]);
          element.controls.respuesta.updateValueAndValidity();
        }
      });
    });
  }
  get getPiecesArray() {
    return <FormArray>this.ionicForm.get("opcion");
  }
  validarPasos() {
    let input: any = document.getElementById("inputsP1") as HTMLInputElement;
    let expresion = input.pattern;
    this.nombreActividad = this.actividadActual.data[0].nombre_actividad;
    let cadena = this.nombreActividad;
    let valid = cadena.match(expresion);
    let p: number = 1;
    if (valid) {
      p++;
      this.validP = p;
    } else {
      this.validP = p;
      input.setFocus();
      return;
    }
    let hab = 0;
    this.habilidad.forEach((element) => {
      if (element.seleccionado) {
        hab++;
      }
    });

    if (hab >= 2) {
      p++;
      this.validP = p;
    } else {
      return;
    }
    this.siPaso4(p);

    console.log("Paso activo: ", this.validP);
  }

  selectPaso(p = 1) {
    this.validarPasos();
    if (p <= this.validP) this.pasos = p;
  }
  next() {
    this.validarPasos();
    if (this.pasos < 4 && this.pasos < this.validP) {
      this.pasos++;
    }
  }
  prev() {
    if (this.pasos > 1) {
      this.pasos--;
    }
  }

  habilidadF(id: number) {
    if (this.modHabilidad == true) {
      let arregloHabilidades = this.habilidad;
      let r: boolean = false;
      let count = 0;
      arregloHabilidades.forEach((element) => {
        if (element.id == id) {
          element.seleccionado = !element.seleccionado;
        }
        if (element.seleccionado) {
          count++;
        }
      });
      if (count < 2) {
        this.validP = 2;
        this.pasos = this.validP;
      }
      this.validarPasos();
      return r;
    } else {
      //Mensaje al usuario
    }
  }

  btnHabilidades() {
    return this.actividadesHabilidades;
  }
  btnTipoEjercicios() {
    return this.actividadesEjercicios;
  }

  minWidth: number;
  puzzleObjData: any = [];
  palabrasEncontradas: any = [];

  eliminarPalabra(i: number, palabra: string) {
    //Lo elimino de la lista de palabras
    this.palabras.splice(i, 1);
    this.puzzleReorder();
    this.validarSopaLetras();
  }

  construirPuzzle() {
    //Se inicializan los valores
    this.puzzleObjData = [];
    this.puzzleObj = [];
    this.dataPuzzle = [];

    let palabras = [];
    palabras = this.palabras;

    let len = this.palabras.length + 1;
    palabras.forEach((element, i) => {
      let p = element.palabra;
      if (p.length + 1 > len) {
        len = p.length + 1;
      }

      let arr = element.codigo.split(",");
      let pal = element.palabra.split("");
      if (
        element.tipo == "verticalR" ||
        element.tipo == "horizontalR" ||
        element.tipo == "diagonalDR"
      ) {
        pal = pal.reverse();
      }

      let abjeto: any = [];
      pal.forEach((letra, j, array) => {
        let a = arr[j];
        abjeto.push({ letra: letra, code: a });
      });

      this.dataPuzzle.push(abjeto);
    });
    console.log("dataPuzzle: ", this.dataPuzzle);
    this.puzzleMin = { y: len, x: len };
    console.log("Tamaño maximo: ", this.puzzleMin);
    // this.minWidth = 46 * len + 30;

    for (let i = 0; i < this.puzzleMin.y; i++) {
      let idY = this.pad(i, 2);
      this.puzzleObjData.push({ idX: [] });
      this.puzzleObj.push({ idY: idY, idX: [] });
      for (let j = 0; j < this.puzzleMin.x; j++) {
        let idX = this.pad(j, 2);
        //r00_c00
        let id_col = "";
        id_col = "r" + idY + "_c" + idX;
        let w = "";
        let code = "";
        this.dataPuzzle.forEach((elA) => {
          elA.forEach((elB) => {
            if (elB.code == "#" + id_col) {
              w = elB.letra;
              code = "#" + id_col;
            }
          });
        });

        this.puzzleObjData[i].idX.push(w);
        this.puzzleObj[i].idX.push(idX);
      }
      if (i == this.puzzleMin.y - 1) {
        this.bandera = 1;
        console.log("puzzleObj 2: ", this.puzzleObjData);
      }
    }
  }

  deleteEliminarRecursoPA() {
    this.ejercicioActivoInfo.actividades.data.tipo_recurso = "";
    this.ejercicioActivoInfo.actividades.data.recurso.file = null;
    this.ejercicioActivoInfo.actividades.data.recurso.b64 = null;
  }

  backP3() {
    this.ejercicioSelected = 0;
  }

  prev2() {
    this.prev();
  }
  next2() {
    this.next();
  }

  addTipo(id) {
    if (this.ejercicios.length > 0) {
      this.ejercicios.forEach((element) => {
        if (element.active) {
          this.select_tipo_ejercicio = id;
          element.tipo = id == 9 ? 4 : id;
          if (id == 1) {
            let temp: any = this.arregloOpcionM;
            element.actividades = temp;
          }
          if (id == 2) {
            let temp: any = this.varFV;
            element.actividades = temp;
          }
          if (id == 3) {
            let temp: any = this.varCompletarE;
            element.actividades = temp;
          }
          if (id == 4) {
            this.AcOrdenarTipo = 1;
            this.ordenarS = JSON.parse(JSON.stringify(this.arregloOrdenar));
            this.ordenarS.data.tipo = 2;
            this.ordenarP = JSON.parse(JSON.stringify(this.arregloOrdenar));
            this.ordenarP.data.tipo = 1;

            let temp = JSON.parse(JSON.stringify(this.arregloOrdenar));
            element.actividades = temp;
          }
          if (id == 9) {
            this.AcOrdenarTipo = 2;
            this.ordenarS = JSON.parse(JSON.stringify(this.arregloOrdenar));
            this.ordenarS.data.tipo = 2;
            this.ordenarP = JSON.parse(JSON.stringify(this.arregloOrdenar));
            this.ordenarP.data.tipo = 1;

            let temp = JSON.parse(JSON.stringify(this.arregloOrdenar));
            element.actividades = temp;
          }
          if (id == 5) {
            this.dataPuzzle = [];
            this.memObjFile = [];
            this.memoriaArrayObj = [];
            element.actividades = this.arregloMemoria;
            //   this.memoriaInitC();
          }
          if (id == 6) {
            let temp: any = this.arregloSopaLetras;
            element.actividades = temp;
            this.puzzleMin = { y: 5, x: 5 };
            this.puzzleObj = [];
            this.bandera = 2;
            this.palabras = [];
            this.initMatriz();
          }
          if (id == 7) {
            let temp: any = this.varClaseE;
            element.actividades = temp;
          }
          if (id == 8) {
            let temp: any = this.varPreguntaA;
            element.actividades = temp;
          }
        } else {
          //element.active = false;
        }
      });
    }
  }

  cancelTipoEjercicio() {
    this.pasos = 3;
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
  }

  /********Sección de actividades*************** */

  /********* */

  /********Fin Sección de actividades*********** */

  initControl() {
    this.countopcion++;
    return this.formBuilder.control({
      id: [this.countopcion, [Validators.required, Validators.minLength(1)]],
      respuesta: [
        "",
        [
          Validators.required,
          Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
        ],
      ],
      verdadero: [false, [Validators.required]],
    });
  }

  addControl() {
    /*id:1,
    respuesta:'',
    verdadero:false*/
    let control = <FormArray>this.ionicForm.controls["opcion"];
    if (control != undefined) {
      control.push(this.initControl());
    } else {
      const op = "opcion";
      this.ionicForm = this.formBuilder.group({
        //opciont: this.formBuilder.array([]),
        opcion: this.formBuilder.array([
          {
            id: [
              this.countopcion,
              [Validators.required, Validators.minLength(1)],
            ],
            respuesta: [
              "",
              [
                Validators.required,
                Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
              ],
            ],
            verdadero: [false, [Validators.required]],
          },
        ]),
      });
      let arrFo: any = this.ionicForm.controls.opcion.value;
      arrFo.forEach((element, i) => {});
    }
    return;
    this.countopcion++;
    this.ionicForm.addControl(
      "respuesta" + this.countopcion,
      new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{3,100}"),
      ])
    );
    /*this.ionicForm.addControl('respuesta:texto' + this.countopcion, new FormControl('', [Validators.required, Validators.pattern('[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{3,100}')]));
    this.ionicForm.addControl('respuesta:verdadero' + this.countopcion, new FormControl(''));*/
  }
  addOpcion() {
    this.id_pos++;

    this["opciones"].push({
      id: this.id_pos,
      respuesta: "",
      verdadero: false,
    });
  }
  deleteOption(id) {
    if (this.opciones.length > 1)
      this.opciones.forEach((element, i) => {
        if (element.id == id) {
          this.opciones.splice(i, 1);
        }
      });
  }
  submitOption() {
    //this.isSubmitted = true;
    if (!this.ionicForm.valid) {
      return false;
    } else {
    }
  }

  eliminarRecursoopcion(id) {
    this.array_option_imgs;
    let arrayImg = this.array_option_imgs;
    let _this = this;
    let index = 0;
    this.array_option_imgs
      .reduce(function (p, element) {
        return p.then(function () {
          if (element.id == id) {
            _this.array_option_imgs.splice(index, 1);
          }
          index++;
        });
      }, Promise.resolve())
      .then(
        function (finalResult) {
          let controls: any = _this.ionicForm.controls.opcion;
          controls.controls.forEach((element) => {
            if (element.controls.id.value == id) {
              element.controls.respuesta.setValidators([
                Validators.required,
                Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
              ]);
              element.controls.respuesta.updateValueAndValidity();
              _this.opMultiVerificar();
            }
          });
        },
        function (err) {
          // error here
        }
      );
  }

  saveLinkY2() {
    //link-youtube
    let inputYoutube: any = document.getElementById("link-youtube");
    console.log("🚀 ~ saveLinkY2 ~ inputYoutube:", inputYoutube);
    let expresion = inputYoutube.pattern;
    let cadena = inputYoutube.value;
    let valid = cadena.match(expresion);
    let link = "";
    if (valid) {
      link = this.link_option_y;
    } else {
      inputYoutube.setFocus();
      return;
    }
    console.log("🚀 ~ saveLinkY2 ~ inputYoutube:", link);

    let id = this.id_option_file;

    this.ejercicioActivoInfo.actividades.dataOp.forEach((elemento) => {
      if (elemento.id == id) {
        console.log(
          "🚀 ~ this.ejercicioActivoInfo.actividades.dataOp.forEach ~ elemento:",
          elemento
        );
        elemento.recurso = link;
        elemento.tipo_recurso = "video";
      }
    });

    this.closeFileAdd();
  }
  saveLinkY() {
    //link-youtube
    let inputYoutube: any = document.getElementById("link-youtube");
    let expresion = inputYoutube.pattern;
    let cadena = inputYoutube.value;
    let valid = cadena.match(expresion);
    let link = "";
    if (valid) {
      link = this.link_option_y;
    } else {
      inputYoutube.setFocus();
      return;
    }

    let id = this.id_option_file;

    let find = false;
    let object = { id: id, link: link, tipo: "video", file: "", b64: "" };
    let _this = this;

    this.array_option_imgs
      .reduce(function (p, element) {
        return p.then(function () {
          if (element.id == id) {
            element.link = link;
            element.tipo = "video";
            (element.file = ""), (element.b64 = "");
            this.ejercicioActivoInfo.actividades.data.recurso = link;
            this.ejercicioActivoInfo.actividades.data.tipo_recurso = "video";
            find = true;
          }
        });
      }, Promise.resolve())
      .then(
        function (finalResult) {
          if (!find) {
            _this.array_option_imgs.push(object);
            _this.link_option_y = "";
          }
          _this.opMultiVerificar();
          _this.closeFileAdd();
          _this.link_option_y = "";
        },
        function (err) {
          // error here
        }
      );
    let controls: any = this.ionicForm.controls.opcion;
    controls.controls.forEach((element) => {
      if (element.controls.id.value == id) {
        element.controls.respuesta.setValidators([
          Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
        ]);
        element.controls.respuesta.updateValueAndValidity();
        _this.opMultiVerificar();
      } else {
        //element.controls.respuesta.setValidators([Validators.required,Validators.pattern('[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}')]);
      }
    });
  }
  removeFileOpQ() {
    this.data_option_tipoQ.tipo = "";
    this.data_option_tipoQ.value = "";
    this.data_option_tipoQ.object = null;
    this.data_option_tipoQ.b64 = "";
    this.id_option_fileQ = 0;
  }

  uploadFileOpQ(event: any) {
    let target: HTMLInputElement = event.target as HTMLInputElement;
    let file: File = target.files[0];
    console.log(file);
    let _this = this;
    let id = this.id_option_file;
    if (FileReader && file) {
      var fr = new FileReader();
      fr.onload = function () {
        //{tipo:'',value:'',object:null,b64:''};
        let b64 = fr.result;
        _this.ejercicioActivoInfo.actividades.data.file = file;
        _this.ejercicioActivoInfo.actividades.data.recurso = b64;
        _this.ejercicioActivoInfo.actividades.data.tipo_recurso = "img";
        _this.data_option_tipoQ.b64 = b64;
        _this.id_option_fileQ = 0;
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
    console.log(this.ejercicioActivoInfo);
  }

  uploadFileOp2(event: EventTarget, i: number) {
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    let id = this.id_option_file;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        _this.closeFileAdd();
        _this.ejercicioActivoInfo.actividades.dataOp.forEach(
          (elemento, indice) => {
            if (elemento.id == id && indice == _this.indiceActual) {
              elemento.recurso = fr.result;
              elemento.file = file;
              elemento.tipo_recurso = "img";
            }
          }
        );
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }

  uploadFileOp(event: EventTarget) {
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let tipo = 1; //banner
    let load = false;
    let _this = this;
    let id = this.id_option_file;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        _this.closeFileAdd();
        let object = {
          id: id,
          file: file,
          b64: fr.result,
          tipo: "img",
          link: "",
        };
        let find = false;

        _this.array_option_imgs
          .reduce(function (p, element) {
            return p.then(function () {
              if (element.id == id) {
                element.file = file;
                element.b64 = fr.result;
                element.tipo = "img";
                element.link = "";
                find = true;
              }
            });
          }, Promise.resolve())
          .then(
            function (finalResult) {
              if (!find) {
                _this.array_option_imgs.push(object);
                let controls: any = _this.ionicForm.controls.opcion;
                controls.controls.forEach((element) => {
                  if (element.controls.id.value == id) {
                    element.controls.respuesta.setValidators([
                      Validators.pattern("[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}"),
                    ]);
                    element.controls.respuesta.updateValueAndValidity();
                    _this.opMultiVerificar();
                  } else {
                    //element.controls.respuesta.setValidators([Validators.required,Validators.pattern('[0-9A-Za-zá-ÿÁ-ÿ .,¿?!¡]{1,100}')]);
                  }
                });
              }
            },
            function (err) {
              // error here
            }
          );
      };
      fr.readAsDataURL(file);
      //this.closeFileAdd();
    }
  }
  closeFileAdd() {
    this.id_option_file = 0;
    this.input_option_tipo = 0;
    let inputBox: any = document.getElementById("file-content");
    inputBox.style.display = "none";
  }

  btnVideoFile() {
    this.input_option_tipo = 1;
  }
  btnImgFile() {
    this.input_option_tipo = 2;
  }

  addFileOpM2() {
    this.id_option_fileQ2 = 1;
  }
  btnVideoFileOP() {
    this.input_option_tipoOP = 1;
  }

  btnVideoFileCE() {}

  btnImgFileOP() {
    this.input_option_tipoOP = 2;
  }

  btnImgFileCE() {
    this.input_option_tipoOP = 2;
  }

  addFileOpPregunta() {
    this.id_option_fileQ = 1;
  }
  closeFileOpPregunta() {
    this.id_option_fileQ = 0;
    this.input_option_tipoQ = 0;
    this.input_option_Q = "";
  }
  saveFileOpPregunta() {
    if (this.input_option_tipoQ == 1) {
    } else if (this.input_option_tipoQ == 2) {
      let input: any = document.getElementById(
        "input-question-y"
      ) as HTMLInputElement;
      let expresion = input.pattern;
      let cadena = input.value;
      let valid = cadena.match(expresion);
      if (!valid) {
        input.setFocus();
        return;
      }
      let value = this.input_option_Q;
      this.data_option_tipoQ.tipo = "video";
      this.data_option_tipoQ.value = value;
      this.data_option_tipoQ.object = null;
      this.data_option_tipoQ.b64 = "";
      console.log("this.data_option_tipoQ: ", this.data_option_tipoQ);
      this.input_option_tipoQ = 0;
      this.id_option_fileQ = 0;

      this.ejercicioActivoInfo.actividades.data.recurso = value;
      this.ejercicioActivoInfo.actividades.data.tipo_recurso = "video";
      console.log("ejercicio activo", this.ejercicioActivoInfo);
    }
  }
  btnImgFileQ() {
    this.input_option_tipoQ = 1;
  }
  btnVideoFileQ() {
    this.input_option_tipoQ = 2;
  }

  cambio() {
    this.modificacion = 3;
    this.desactivado = false;
  }

  addFileOp(id, i, el) {
    this.indiceActual = i;

    if (this.id_option_file > 0) {
      if (this.id_option_file != id) {
        return;
      }
      this.closeFileAdd();
      return;
    }

    this.id_option_file = id;
    let input: any = document.getElementById(el);
    var rec = input.offsetHeight;
    let inputBox: any = document.getElementById("file-content");
    inputBox.style.top = rec * i + 52 + "px";
    inputBox.style.display = "block";
    console.log("ID: ", id);
    console.log("rec.top: ", rec);
  }

  /*****CORE VERDADERO/FALSO******** */
  setVF(vf: number) {
    this.ejercicioActivoInfo.actividades.data.vf = vf;
  }
  validInput(input, focus = false) {
    const isTextarea = input.tagName?.toLowerCase() === "textarea";
    const cadena = input.value;
    const expresion = !isTextarea ? input.pattern : null;

    // Validar si existe texto
    if (cadena) {
      if (isTextarea) {
        // Validamos solo la longitud si es textarea
        if (cadena.length <= this.maxLengthTextArea) {
          return true;
        }
      } else {
        // Si hay patrón, lo validamos
        if (!expresion || cadena.match(expresion)?.[0] === cadena) {
          return true;
        }
      }

      // Si no pasó la validación
      if (focus) input.setFocus?.();
      return false;
    } else {
      // Si el campo está vacío, solo pasa si no es requerido
      if (!input.required) {
        return true;
      } else {
        if (focus) input.setFocus?.();
        return false;
      }
    }
  }

  verificarVF(toastM = true, focus = true) {
    let valid = 0;
    //vfExpl
    let inputExp: any = document.getElementById("vfExpl") as HTMLInputElement;
    if (!this.validInput(inputExp, focus)) {
      valid++;
    }
    let inputPreg: any = document.getElementById(
      "vfPregunta"
    ) as HTMLInputElement;
    if (!this.validInput(inputPreg, focus)) {
      valid++;
    }

    if (valid == 0) {
      this.validoGuardar = true;
      this.validoCrear = true;
    } else {
      this.validoGuardar = false;
      this.validoCrear = false;
      return false;
    }
  }
  guardarVerdaderoFalso() {
    //vfPregunta
    let inpuPreg: any = document.getElementById(
      "vfPregunta"
    ) as HTMLInputElement;
    if (!this.validInput(inpuPreg, true)) {
      return;
    }
    //vfExpl
    let inputExp: any = document.getElementById("vfExpl") as HTMLInputElement;
    if (!this.validInput(inputExp, true)) {
      return;
    }
    let pregunta = this.fvPregunta;
    let ejercicio = this.ejercicioActivo;
    let vf = this.fvFV;
    let explicacion = inputExp.value;
    let select_tipo_ejercicio = this.select_tipo_ejercicio;
    let objTemp = {
      ej: ejercicio,
      tipo: select_tipo_ejercicio,
      pregunta: pregunta,
      vf: vf,
      explicacion: explicacion,
    };
    this.dataVF.push(objTemp);
    this.vfLimpiarForm();
  }
  vfLimpiarForm() {
    this.opcionExplicacion = "";
    this.fvPregunta = "";
    this.fvFV = "";
  }
  /***********FIN CORE VERDADERO/FALSO*********************** */
  ngOnDestroy() {
    this.dragulaService.destroy("bag");
    this.subscription.unsubscribe();
    this.actividadesEjercicios = [];
    this.actividadesHabilidades = [];
  }

  public subscription = this.stringVar$.subscribe((data) => {
    // do stuff with data
    // e.g. this.property = data
    if (data.valid) {
      this.paso3Active = true;
    } else {
      this.paso3Active = false;
    }
  });

  public updateStringSubject() {
    let actual: any = this.stringVar.asObservable();
    let temp: any = actual.source._value;
    temp.valid = this.verificarVF(false, false);
    this.stringVar.next(temp);
  }

  vfVerificar() {
    this.updateStringSubject();
  }
  /********Core Completa el espacio****** */
  completaespacioGuardar() {
    this.textAreaVerific();
    //dataAreacomplateEspacio
    let tipoejercicio = this.ejercicioSelected;
    this.dataAreacomplateEspacio.tipo = tipoejercicio;
    let valor = this.textAreacomplateEspacio;
    this.dataAreacomplateEspacio.valor = valor;
    let explicacon = this.explAreacomplateEspacio;
    let temp = this.dataAreacomplateEspacio;
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;

    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        temp.explicacion = explicacon;
        element.actividades.push(temp);

        this.dataAreacomplateEspacio = [];
        this.respuestasAreacomplateEspacio = [];
        this.ejercicioSelected = 0;
        this.select_tipo_ejercicio = 0;
        this.textAreacomplateEspacio = "";
        this.explAreacomplateEspacio = "";
        console.log("ejercicios: ", this.ejercicios);
        this.siPaso4();
        this.validarPasos();
      }
    });
  }
  textAreaVerific() {
    console.log("textAreacomplateEspacio: ", this.textAreacomplateEspacio);
    let inputArea: any = document.getElementById(
      "completa-area-id"
    ) as HTMLInputElement;
    let expresion = inputArea.pattern;
    let cadena = this.ejercicioActivoInfo.actividades.data.pregunta;
    let valid = cadena.match(expresion);
    let error = 0;
    //explAreacomplateEspacio
    let inpuCompAreaExpl: any = document.getElementById(
      "completa-espacio-expl"
    ) as HTMLInputElement;
    let expresion2 = inpuCompAreaExpl.pattern;
    let cadena2 = this.ejercicioActivoInfo.actividades.data.explicacion;
    let valid2 = cadena2.match(expresion2);
    if (!valid) {
      error++;
    }
    if (cadena2)
      if (!valid2) {
        error++;
      }
    //completa-area-id
    let tesst = this.ejercicioActivoInfo.actividades.data.pregunta;
    let test: any = tesst.match(/\[([^\[]*)\]/g);
    if (test != null) {
      for (let i = 0; i < test.length; i++) {
        test[i] = test[i].replace(/\[/g, "");
        test[i] = test[i].replace(/\]/g, "");
      }
      this.respuestasAreacomplateEspacio = test;
    } else {
      this.respuestasAreacomplateEspacio = [];
    }
    if (this.respuestasAreacomplateEspacio.length > 0 && error == 0) {
      this.validoGuardar = true;
      this.validoCrear = true;
      this.paso3Active = true;
    } else {
      this.validoGuardar = false;
      this.validoCrear = false;
      this.paso3Active = false;
    }
    console.log("test: ", this.respuestasAreacomplateEspacio);
  }
  /********************** */
  /********Core Pregunta abierta****** */
  preguntaAbiertaVerificar() {
    let inputText: any = document.getElementById(
      "preguntaAbierta-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      this.validoCrear = true;
      this.validoGuardar = true;
      this.paso3Active = true;
    } else {
      this.validoCrear = false;
      this.validoGuardar = false;
      this.paso3Active = false;
    }
  }
  savePreguntaAbieta() {
    //data_preguntaAbierta:any = {tipo:0,pregunta:'',recurso:{tipo:'',object:null}};
    let inputText: any = document.getElementById(
      "preguntaAbierta-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      let temp = this.ejercicioActivoInfo.actividades.data;

      let new_temp = { id_tipo: this.select_tipo_ejercicio };
      let merged = Object.assign(new_temp, temp);
      temp = merged;
      this.ejercicios.forEach((element) => {
        if (element.active) {
          temp.tipo = element.tipo;
          element.actividades.push(temp);
          this.ejercicioSelected = 0;
          this.select_tipo_ejercicio = 0;
          this.id_preguntaA_file = 0;
          this.input_preguntaA_tipo = 0;
          this.siPaso4();
          this.validarPasos();
        }
      });
      this.paso3Active = false;
    }
    console.log("ejercicios: ", this.ejercicios);
  }
  addFilePreguntaAbierta() {
    this.id_preguntaA_file = 1;
  }
  btnImgFilePA() {
    this.input_preguntaA_tipo = 1;
  }
  btnVideoFilePA() {
    this.input_preguntaA_tipo = 2;
  }
  removeFilePA() {
    this.ejercicioActivoInfo.actividades.data.recurso = null;
    this.ejercicioActivoInfo.actividades.data.tipo_recurso = null;
  }
  saveFilePreguntaA() {
    //input_pa_y
    //recurso_pregunta_abierta:any = {tipo:'',value:'',object:null,b64:''};
    let inputText: any = document.getElementById(
      "input-pa-y"
    ) as HTMLInputElement;
    // if (this.validInput(inputText, true)) {

    this.ejercicioActivoInfo.actividades.data.recurso.file = this.input_pa_y;
    this.ejercicioActivoInfo.actividades.data.tipo_recurso = "video";
    this.id_preguntaA_file = 0;
    this.input_preguntaA_tipo = 0;
  }
  closeFilePreguntaA() {
    this.id_preguntaA_file = 0;
    this.input_preguntaA_tipo = 0;
  }

  uploadFilePA(event: EventTarget) {
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let files = target.files;
    let file: File = target.files[0];
    let _this = this;
    let id = this.id_option_file;
    if (FileReader && file && files.length) {
      var fr = new FileReader();
      fr.onload = function () {
        //{tipo:'',value:'',object:null,b64:''};
        let b64 = fr.result;
        _this.ejercicioActivoInfo.actividades.data.recurso.file = file;
        _this.ejercicioActivoInfo.actividades.data.recurso.b64 = b64;
        _this.ejercicioActivoInfo.actividades.data.tipo_recurso = "img";
        _this.id_preguntaA_file = 0;
        _this.input_preguntaA_tipo = 0;
      };
      fr.readAsDataURL(file);
    }
  }

  /********Fin Core Pregunta abierta****** */

  /********Core Clase de explicación****** */
  claseExplicacionVerificar() {
    let inputText: any = document.getElementById(
      "claseExplicacion-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      console.log(
        "this.ejercicioActivoInfo.actividades.data.recurso: ",
        this.ejercicioActivoInfo.actividades.data.recurso
      );
      this.paso3Active = true;
      this.validoCrear = true;
      this.validoGuardar = true;
      // if (this.ejercicioActivoInfo.actividades.data.recurso) {
      //   this.paso3Active = true;
      //   this.validoCrear = true;
      // } else {
      //   this.paso3Active = false;
      //   this.validoCrear = false;
      // }
    } else {
      this.paso3Active = false;
      this.validoCrear = false;
      this.validoGuardar = false;
    }
  }
  // embedUrl| null = null;
  embedVideo(url): SafeResourceUrl | null {
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    if (youtubeRegex.test(url)) {
      const videoId = url.match(youtubeRegex)[1];
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );
    } else {
      return null;
    }
  }
  claseExplicacionVerificarExp() {
    let inputText: any = document.getElementById(
      "claseExplicacionExp-id"
    ) as HTMLInputElement;
    if (this.validInput(inputText, true)) {
      if (this.ejercicioActivoInfo.actividades.data.recurso) {
        this.paso3Active = true;
      } else {
        this.paso3Active = false;
      }
    } else {
      this.paso3Active = false;
    }
  }
  b64toBlob(b64Data, contentType) {
    contentType = contentType || "";
    var sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  saveOrdenar() {
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    console.log("🚀 ~ saveOrdenar ~ this.AcOrdenarTipo:", this.AcOrdenarTipo);

    // Verifica si el tipo de ejercicio es 1 o 2
    if (this.AcOrdenarTipo == 1) {
      let AcOrdenarTipo = this.AcOrdenarTipo;
      let explicacion = this.ordenarExplicacion;

      // Crear una copia independiente del objeto
      let temp = {
        ...new_temp,
        tipo: AcOrdenarTipo,
        explicacion: explicacion,
        data: [...this.ordenarArrayP], // Crea una copia de ordenarArrayP
      };

      this.ejercicios.forEach((element) => {
        if (element.active) {
          element.actividades.push(temp); // Agregar la copia
          this.siPaso4();
          this.validarPasos();
          this.resetOrdenar();
          this.AcOrdenarTipo = 1;
          this.ejercicioSelected = 0;
          this.ordenarExplicacion = "";
          this.select_tipo_ejercicio = 0;
          console.log("this.ejercicios: ", this.ejercicios);
        }
      });
    } else if (this.AcOrdenarTipo == 2) {
      let AcOrdenarTipo = this.AcOrdenarTipo;
      let explicacion = this.ordenarExplicacion;

      // Crear una copia independiente del objeto
      let temp = {
        ...new_temp,
        tipo: AcOrdenarTipo,
        explicacion: explicacion,
        data: [...this.ordenarArrayS], // Crea una copia de ordenarArrayS
      };

      this.ejercicios.forEach((element) => {
        if (element.active) {
          element.actividades.push(temp); // Agregar la copia
          this.resetOrdenar();
          this.AcOrdenarTipo = 1;
          this.ejercicioSelected = 0;
          this.ordenarExplicacion = "";
          this.select_tipo_ejercicio = 0;
          console.log("this.ejercicios: ", this.ejercicios);
        }
      });
    }
  }

  saveMemoria() {
    //data_Memoria
    //this.ejercicioSelected = 0;

    this.data_Memoria = [
      { tipo: this.ejercicioSelected, data: this.memoriaArrayObj },
    ];
    let temp = this.data_Memoria;
    console.log("temp: ", temp);
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;
    console.log("merged: ", temp);
    temp = merged;
    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        element.actividades.push(temp);
        this.siPaso4();
        this.validarPasos();
        this.ejercicioSelected = 0;
        this.select_tipo_ejercicio = 0;
        this.resetMemoria();
      }
    });
    this.paso3Active = false;
    console.log("ejercicios: ", this.ejercicios);
  }

  validarSopaLetras() {
    if (this.palabras.length > 2) {
      this.validoGuardar = true;
      this.validoCrear = true;
    } else {
      this.validoGuardar = false;
      this.validoCrear = false;
    }
  }

  /**************** */
  saveSopaLetras() {
    //data_SopaLetras = {tipo:0,valor:null};
    this.data_SopaLetras.tipo = this.ejercicioSelected = 0;
    this.data_SopaLetras.valor = this.palabras;

    let temp = this.data_SopaLetras;

    //console.log("temp: ",temp);
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;
    //console.log("merged: ",temp);

    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        element.actividades.push(temp);
        this.siPaso4();
        this.validarPasos();
        this.data_SopaLetras = { tipo: 0, valor: null };
        this.palabras = [];
        this.ejercicioSelected = 0;
        this.select_tipo_ejercicio = 0;
      }
    });
    this.paso3Active = false;
    console.log("ejercicios: ", this.ejercicios);
  }
  saveClaseExplicacion() {
    //claseExplicacionExp
    this.data_ClaseExplicacion.explicaciontemaExpl =
      this.ejercicioActivoInfo.actividades.data.explicaciontema;
    this.data_ClaseExplicacion.explicaciontema =
      this.ejercicioActivoInfo.actividades.data.explicacion;
    this.data_ClaseExplicacion.tipo = this.ejercicioSelected = 0;
    this.data_ClaseExplicacion.link_video =
      this.ejercicioActivoInfo.actividades.data.recurso;
    let temp = this.data_ClaseExplicacion;

    //console.log("temp: ",temp);
    let new_temp = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(new_temp, temp);
    temp = merged;
    //console.log("merged: ",temp);

    this.ejercicios.forEach((element) => {
      if (element.active) {
        temp.tipo = element.tipo;
        element.actividades.push(temp);

        this.data_ClaseExplicacion = {
          tipo: 0,
          explicaciontema: "",
          explicaciontemaExp: "",
          recurso: { tipo: "", object: null },
        };
        this.ejercicioSelected = 0;
        this.select_tipo_ejercicio = 0;
        this.id_claseExplicacion_file = 0;
        this.input_claseE_tipo = 0;
        this.siPaso4();
        this.validarPasos();
      }
    });
    this.paso3Active = false;
    console.log("ejercicios: ", this.ejercicios);
  }
  /********Fin Core Clase de explicación****** */
  validarOpMultiInput(input) {
    let expresion = input.pattern;
  }
  /**Opción 1:  Opción múltiple */
  opMultiples() {
    return {
      data: {
        id_ejercicio: null,
        pregunta: "",
        recurso: {
          valor: "",
          tipo: "", //link,imagen
        },
        explicacion: "",
        opciones: [
          {
            id: 0,
            respuesta: "",
            verdadero: false,
            recurso: {
              valor: "",
              tipo: "", //link,imagen
            },
          },
        ],
      },
    };
  }

  validacionCheck(item: any) {
    if (item.vf == 0) return false;
    else return true;
  }

  onRadioChange(value: any) {
    if (value.target.id != "input-multi-op") {
      this.ejercicioActivoInfo.actividades.dataOp.forEach((item, index) => {
        item.vf = index === value.detail.value ? 1 : 0;
      });
    }
    this.opMultiVerificar();
  }

  opMultiVerificar(save = false) {
    let inputText: any = document.getElementById(
      "opMultpregunta"
    ) as HTMLInputElement;

    let temp: any = this.opMultiples();
    let err = 0;
    if (this.validInput(inputText, false)) {
      temp.data.pregunta = this.opcionPregunta;
    } else {
      temp.data.pregunta = "";
      err++;
    }

    const input = this.ejercicioActivoInfo.actividades.dataOp.every(
      (item) => item.opcion && item.opcion.trim() !== ""
    );
    if (!input) {
      err++;
    }

    const tieneActivo = this.ejercicioActivoInfo.actividades.dataOp.some(
      (item) => item.vf === 1
    );
    if (!tieneActivo) {
      err++;
    }
    this.opMultipleData.push(temp);

    console.log("🚀 ~ opMultiVerificar ~ err:", err);
    if (err == 0) {
      this.validoGuardar = true;
      this.validoCrear = true;
      this.paso3Active = true;
    } else {
      this.validoGuardar = false;
      this.validoCrear = false;
    }
  }

  cancelarCreacion() {
    this.pasos = 3;
    this.ejercicioSelected = 0;
    this.modificacion = 3;
    console.log(this.ejercicios);
    this.ejercicios.pop();
  }

  siPaso4(p = 0) {
    let total = this.ejercicios.length;
    let finalizados = 0;
    let result: boolean = false;
    if (this.ejercicios.length > 0) {
      if (p >= 3) {
        this.validP = 4;
      }

      console.log("Paso 4 activo: ", this.validP);
      result = true;
      // this.ejercicios.forEach((element, index, array) => {

      //   console.log("pelota", this.ejercicios);
      //   if (element.length > 0) {
      //     finalizados++;
      //   }
      //   if (index == array.length - 1) {
      //     console.log('total: ', total);
      //     console.log('finalizados: ', finalizados);
      //     if (finalizados == total) {
      //       if (p >= 3) {
      //         this.validP = 4;
      //       }

      //       console.log('Paso 4 activo: ', this.validP);
      //       result = true;
      //     } else {
      //       result = false;
      //     }
      //     return result;
      //   }
      // });
    } else {
      return result;
    }
  }
  finalizarP3() {
    switch (this.select_tipo_ejercicio) {
      case 1:
        this.saveMultiOpt();
        break;
      case 2:
        this.saveFV();
        break;
      case 3:
        this.completaespacioGuardar();
        break;
      case 4:
        this.saveOrdenar();
        break;
      case 5:
        this.saveMemoria();
        break;
      case 6:
        this.saveSopaLetras();
        break;
      case 7:
        this.saveClaseExplicacion();
        break;
      case 8:
        this.savePreguntaAbieta();
        break;
      //
    }
  }
  saveMultiOpt() {
    this.opMultiVerificar(true);
    let temp = this.opMultipleData[this.opMultipleData.length - 1];
    //let opMultipleData = temp;
    let opMultipleData;

    let temp_new = { id_tipo: this.select_tipo_ejercicio };
    let merged = Object.assign(temp_new, temp.data);
    opMultipleData = { data: merged };
    console.log("opMultipleData: ", opMultipleData);
    //return;
    if (this.data_option_tipoQ.tipo != "") {
      let tipoQ = this.data_option_tipoQ.tipo;
      opMultipleData.data.recurso.tipo = tipoQ;
      if (tipoQ == "img") {
        let img = this.data_option_tipoQ.object;
        opMultipleData.data.recurso.valor = img;
      } else {
        let link = this.data_option_tipoQ.value;
        opMultipleData.data.recurso.valor = link;
      }
      this.data_option_tipoQ.tipo = "";
      this.data_option_tipoQ.value = "";
      this.data_option_tipoQ.object = null;
      this.data_option_tipoQ.b64 = "";
    }

    let tipoejercicio = this.ejercicioSelected;
    this.opMultipleData.tipo = tipoejercicio;
    this.array_option_imgs.forEach((element1) => {
      //this.opMultipleData.forEach(opMultiple => {//
      opMultipleData.data.opciones.forEach((op) => {
        if (element1.id == op.id) {
          op.recurso.tipo = element1.tipo;
          if (op.recurso.tipo == "img") {
            op.recurso.valor = element1.file;
          } else {
            op.recurso.tipo = element1.tipo;
            op.recurso.valor = element1.link;
          }
        }
      });
      //});
    });
    this.opcionExplicacion = "";
    this.opcionPregunta = "";
    this.array_option_imgs = [];
    this.ionicForm = this.formBuilder.group({
      opcion: this.formBuilder.array([]),
    });
    this.countopcion = 0;
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    console.log("ejercicios: ", this.ejercicios);
    this.ejercicios.forEach((element) => {
      if (element.active) {
        element.actividades.push(opMultipleData);
        this.siPaso4();
        this.validarPasos();
      }
    });

    this.opMultipleData = [];
  }
  saveFV() {
    let tipoejercicio = this.ejercicioSelected;
    this.select_tipo_ejercicio;
    let temp = {
      tipo: this.ejercicioActivo,
      pregunta: this.fvPregunta,
      vf: this.fvFV,
      explicacion: this.opcionExplicacion,
      id_tipo: this.select_tipo_ejercicio,
      id_ejercicio: null,
    };
    console.log("this.select_tipo_ejercicio: ", temp);
    this.dataVF.push(temp);
    this.vfLimpiarForm();
    this.ejercicioSelected = 0;
    this.select_tipo_ejercicio = 0;
    this.ejercicios.forEach((element) => {
      if (element.active) {
        element.actividades.push(temp);
        this.siPaso4();
        this.validarPasos();
      }
    });
    console.log("ejercicios: ", this.ejercicios);
  }

  resetALL() {
    this.dragulaService.destroy("bag");
    this.dragulaService.destroy("bag2");
    this.dragulaService.destroy("bag3");
    this.subscription.unsubscribe();
    this.actividadesEjercicios = [];
    this.actividadesHabilidades = [];
    this.palabraInput = "";
    this.data_SopaLetras = { tipo: 0, valor: null };
    this.puzzleMin = { y: 5, x: 5 };
    this.puzzleMax = 10;
    this.puzzleObj = [];
    this.flagOpen = "";
    this.word = "";
    this.flagClosed = "";
    this.codigos = [];
    this.flagOpenTemp = "";
    this.palabras = [];
    this.palabraInput = "";
    //saveMemoria()
    this.data_Memoria = [];
    this.memoriaArray = [];
    this.memoriaSize = { x: 6, y: 6 };
    this.memoriaArrayObj = [];
    this.memObjItems = [];
    this.memObjFile = [];
    this.itemEditMem = null;
    /****Ordenar******** */
    this.AcOrdenarTipo = 1;
    this.ordenarExplicacion = "";
    this.ordenarArrayP = [{ tipo: 1, input: "", recurso: null }];
    this.ordenarArrayS = [{ tipo: 2, input: "", file: null }];
    this.data_ordenar = [{ tipo: 0, explicacion: "", data: null }];
    /******Clase de explicación******** */
    this.id_claseExplicacion_file = 0;
    this.input_claseE_tipo = 0;
    this.input_ce_y = "";
    this.formato = "";
    this.data_ClaseExplicacion = {
      tipo: 0,
      explicaciontema: "",
      explicaciontemaExp: "",
      recurso: { tipo: "", object: null },
    };
    /******Pregunta abierta******** */
    this.input_pa_y = "";
    this.id_preguntaA_file = 0;
    this.input_preguntaA_tipo = 0;
    /******Completa el espacio******** */
    this.textAreacomplateEspacio = "";
    this.explAreacomplateEspacio = "";
    this.respuestasAreacomplateEspacio = [];
    this.dataAreacomplateEspacio = { tipo: 0, valor: "", explicacion: "" };
    /******Variables FalsoVerdadero******** */
    this.fvPregunta = "";
    this.fvFV = "";
    this.dataVF = [];
    this.opcionExplicacion = "";
    this.opcionPregunta = "";
    this.paso3Active = false;
    this.opMultipleData = [];
    this.btnLinkyoutube = false;
    /**************** */
    this.opcionExplicacion = "";
    this.opcionPregunta = "";
    this.paso3Active = false;
    this.opMultipleData = [];
    this.btnLinkyoutube = false;
    /**************** */
    this.habilidad = [];
    this.ejercicios = [];
    this.ejerciciosData = [];
    this.tipo_ejercicios = [];
    this.select_tipo_ejercicio = 0;
    this.ejercicioSelected = 0;
    this.ejercicioActivo = 0;
    this.initreorder = true;
  }

  guardarCambios() {
    if (confirm("¿Deseas guardar los cambios?")) {
      this.finalizarActividad();
    }
  }

  publicarActividad() {
    if (
      confirm(
        "Recuerda que después de publicar la actividad no puedes modificarla: ¿Deseas publicar la actividad?"
      )
    ) {
      this.finalizarActividad();
    }
  }

  finalizarActividad() {
    //actividadesEjercicios:any = [];
    //actividadesHabilidades:any = [];
    this.reload = true;
    let habilidades: any = [];
    let libros: any = [];
    this.actividadesHabilidades.forEach((element, index, array) => {
      if (element.seleccionado) {
        habilidades.push({
          id: element.id,
          index: element.index,
          valor: element.valor,
        });
      }
      if (index == array.length - 1) {
        let fechaStart = "";
        let fechaEnd = "";
        if (this.isFechaHoraEntrega == 1) {
          fechaStart = this.datePipe.transform(
            this.fecha.start,
            "yyyy-MM-dd H:mm"
          );
          fechaEnd = this.datePipe.transform(this.fecha.end, "yyyy-MM-dd H:mm");
        }
        let tempData = {
          id_user: this.id_user,
          nombre_actividad: this.nombreActividad,
          habilidades: habilidades,
          fecha: fechaStart,
          fecha_fin: fechaEnd,
          ejercicios: this.ejercicios,
          libros: libros,
          id_curso: this.curso.id,
        };
        this.ejerciciosData = [tempData];
        console.log("this.ejerciciosData: ", this.ejerciciosData);
        this.showLoader();
        this.actividadesService
          .updateActividad(
            this.auth_key,
            this.ejerciciosData,
            this.actividadActual.data[0].id
          )
          .subscribe(
            async (response) => {
              let result: any = response;
              let message = "";
              if (result.error == 0) {
                this.resetALL();
                message = "Se registraron los cambios satisfactoriamente";
              } else {
                if (!result.auth_key) {
                  //this.authService.logout();
                } else {
                  this.reload = false;
                  message = "Ocurrió un error, inténtelo más tarde";
                }
              }
              this.hideLoader();
              await this.saveAllMsg(message);
              if (result.error == 0) {
                this.dataService.itemSelectedMenu.next(1);
              }
            },
            (error) => {
              this.hideLoader();
            }
          );
      }
    });
  }
  getDateActi() {
    console.log("Fecha: ", this.fecha);
  }
  generateUUID() {
    return UUID.UUID();
  }

  showLoader() {
    this.loadingCtrl
      .create({
        message: "Procesando...",
      })
      .then((res) => {
        res.present();
        res.onDidDismiss().then((dis) => {});
      });
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingCtrl.dismiss();
    }, 200);
  }

  reorderItems(ev) {
    const itemMove = this.ejercicioActivoInfo.actividades.dataOp.splice(
      ev.detail.from,
      1
    )[0];
    this.ejercicioActivoInfo.actividades.dataOp.splice(
      ev.detail.to,
      0,
      itemMove
    );
    ev.detail.complete();
  }

  converDateIso(date) {
    let isoDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    return isoDate;
  }

  deleteItem(item) {
    this.memObjFile = this.memObjFile.filter(
      (element) => element.code != item.code
    );
    this.memoriaArrayObj = this.memoriaArrayObj.map((element) => {
      element.x = element.x.filter((elementX) => elementX.code != item.code);
      return element;
    });
    this.selectedFiles = this.selectedFiles.filter((element) => {
      if (element instanceof File) {
        return element.name != item.name;
      } else {
        return element != item.original;
      }
    });
    item.original ? this.memoriaArrayDeleteItems.push(item.original) : null;
  }

  onFileChange(event: any) {
    const input = event.target as HTMLInputElement;
    const files: FileList = input.files as FileList;
    const validImageTypes = [
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/svg+xml",
      "image/webp",
    ];

    // Reset error message and selected files
    this.errorMessage = "";

    // Check the number of files
    var countFiles = this.selectedFiles.length + files.length;
    if (countFiles < 2) {
      this.errorMessage = "Debes seleccionar al menos 2 imágenes.";
      return;
    }

    if (countFiles > 18) {
      this.errorMessage = "No puedes seleccionar más de 18 imágenes.";
      return;
    }

    // Validate each file type
    for (let i = 0; i < files.length; i++) {
      if (!validImageTypes.includes(files[i].type)) {
        this.errorMessage =
          "Solo puedes seleccionar archivos de imagen (jpg, jpeg, png, gif, svg, webp).";
        return;
      }
      this.selectedFiles.push(files[i]);
    }

    // Update form control value
    this.form.patchValue({
      images: this.selectedFiles,
    });
    this.form.get("images")?.updateValueAndValidity();
    if (this.form.valid) {
      input.value = "";
      this.memoriaInit();
    }
  }

  fileValidator(control: any) {
    if (!control.value || control.value.length === 0) {
      return { required: true };
    }

    if (control.value.length < 2) {
      return { minFiles: true };
    }

    if (control.value.length > 20) {
      return { maxFiles: true };
    }

    return null;
  }
  async handleFileOrUrlChange(ev: Event) {
    const popover = await this.popoverCtrl.create({
      component: ModalLoadFilesComponent,
      event: ev,
      translucent: true,
      showBackdrop: true,
      cssClass: "custom-files-popover",
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      if (data.type == 1) {
        this.ejercicioActivoInfo.actividades.data.recurso = data.url;
        this.ejercicioActivoInfo.actividades.data.file = data.file;
        this.ejercicioActivoInfo.actividades.data.tipo_recurso = "img";
        this.ejercicioActivoInfo.actividades.data.link_video = null;
      } else if (data.type == 2) {
        this.ejercicioActivoInfo.actividades.data.file = null;
        this.ejercicioActivoInfo.actividades.data.tipo_recurso = "";
        this.ejercicioActivoInfo.actividades.data.link_video = data.url;
        this.ejercicioActivoInfo.actividades.data.recurso = this.embedVideo(
          data.url
        );
      }
    }
    this.claseExplicacionVerificar();
  }
  async uploadFileOrUrlPA(ev: Event) {
    const popover = await this.popoverCtrl.create({
      component: ModalLoadFilesComponent,
      event: ev,
      translucent: true,
      showBackdrop: true,
      cssClass: "custom-files-popover",
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data.type == 1) {
     this.ejercicioActivoInfo.actividades.data.tipo_recurso = "img";
      this.ejercicioActivoInfo.actividades.data.recurso = data.url;
      this.ejercicioActivoInfo.actividades.data.file = data.file;
      this.id_preguntaA_file = 0;
      this.input_preguntaA_tipo = 0;
    }else if (data.type == 2) {
      this.ejercicioActivoInfo.actividades.data.tipo_recurso = "video";
      this.ejercicioActivoInfo.actividades.data.recurso = data.url;
      this.ejercicioActivoInfo.actividades.data.file = null;
      this.id_preguntaA_file = 0;
      this.input_preguntaA_tipo = 0;
    }
  }

  redirectTo(url: string): void {
    window.open(url, "_blank");
  }

  getLocalURL(archivo: File): string {
    return URL.createObjectURL(archivo);
  }

  updateUrlImages() {
    this.ejercicios.forEach((item) => {
      // Actualiza el recurso en `data` si existe
      if (item.actividades?.data?.recurso) {
        item.actividades.data.original = item.actividades.data.recurso;
        item.actividades.data.recurso =
          item.actividades.data.tipo_recurso === "video"
            ? item.actividades.data.recurso
            : this.host + item.actividades.data.recurso;
      }

      // Recorre y actualiza los recursos en `dataOp` si existen
      item.actividades?.dataOp?.forEach((option) => {
        if (option.recurso) {
          option.original = option.recurso;
          option.recurso =
            option.tipo_recurso === "video"
              ? option.recurso
              : this.host + option.recurso;
        }
      });
    });
  }
  getNameEjercicio(id) {
    let name = "";
    this.tipo_ejercicios.forEach((element) => {
      if (element.id == id) {
        name = element.titulo;
      }
      if (id == 9) {
        name = "Secuencia";
      }
    });
    return name;
  }
}
